<div class="progressCls"></div>
<div *ngIf="showProgressBar || showEditProgressBar || showLoading">
  <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>
<div *ngIf="showProgressspinner">
  <div class="lmask"></div>
</div>

<div *ngIf="showForms" class="tab">
  <mat-tab-group #matgroup (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTabIndex">
    <!--Location Tab starts from here-->
    <mat-tab *ngIf="showLocationEnable==1?false:true">
      <ng-template mat-tab-label>
        <span>Edit Location Info</span> &nbsp;
        <div *ngIf="locationInfoForm.invalid || nodesForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      {{enablestatus()}}
      <form id="locationInfoForm" [formGroup]="locationInfoForm">
        <input (ngModelChange)="onchangeSave()" type="hidden" formControlName="locationInfoFormInput" [ngModel]="locationInfoForm.invalid ||
        transponderInfoForm.invalid ||
        apuFormGroup.invalid ||
        apuVisitFormGroup.invalid ||
        batteryInfoForm.invalid ||
        batteryStringForm.invalid ||
        batteryBatteryForm.invalid ||
        lastVisitInfoForm.invalid ||
        nodesForm.invalid ||
        vm?.mandatoryImagesMissing">
        <div align="center">
          <br>
          <div>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['houseNumberInput'])"  placeholder="House Number" type='text' [(ngModel)]="locationInfoForm.houseNumberInput"
                (ngModelChange)="onChangeSysContact()" formControlName="houseNumberInput">
                <!-- <mat-error *ngIf="locationInfoForm.get('houseNumberInput').errors?.required">
                  House Number is <strong>required</strong>
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input formControlName="street" matInput placeholder="Street" [(ngModel)]="locationInfoForm.street"
                     (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['street'])"
                     (ngModelChange)="onChangeSysContact()">
              <mat-error *ngIf="locationInfoForm.get('street').errors?.required">
                Street is <strong>required</strong>
              </mat-error>
              <span matSuffix class="macButton">
                <a href="https://www.google.com/maps/place/{{locationInfoForm.houseNumberInput}}+{{locationInfoForm.street}}+{{locationInfoForm.city}}+{{locationInfoForm.state}}+{{locationInfoForm.zip}}"
                  target='_blank'>
                  <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                </a>
              </span>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['crossStreet'])" placeholder="Cross Street" [(ngModel)]="locationInfoForm.crossStreet"
                (ngModelChange)="onChangeSysContact()" formControlName="crossStreet">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input formControlName="city" matInput placeholder="City" [(ngModel)]="locationInfoForm.city"
                     (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['city'])"
                     (ngModelChange)="onChangeSysContact()">
              <mat-error *ngIf="locationInfoForm.get('city').errors?.required">
                City is <strong>required</strong>
              </mat-error>

            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="state" placeholder="State" [(ngModel)]="locationInfoForm.state"
                          (ngModelChange)="onChangeSysContact()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of states" [value]="state">
                  {{state}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationInfoForm.get('state').errors?.required">
                Select State
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input formControlName="zip" matInput maxlength="5"  minlength="5" placeholder="Zip xxxxx"
                     [(ngModel)]="locationInfoForm.zip"
                     (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['zip'])"
                     (keypress)="numberOnly($event)" (paste)="restrictSpecialPaste($event)">
              <mat-error *ngIf="locationInfoForm.get('zip').errors?.required">
                Zip is <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['prevNodeServed'])" placeholder="Previous Node Served" formControlName="prevNodeServed">
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['primaryNode'])" placeholder="Node" formControlName="primaryNode">
            </mat-form-field>
            <p>
              <mat-checkbox [disabled]="showLocationEnable==2" (click)="validateFiberNodes()" class="pstypeIcon">
              </mat-checkbox>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="mutliNodes" placeholder="Feed Multiple Nodes"
                            [(ngModel)]="locationInfoForm.mutliNodes" (ngModelChange)="onChangeSysContact()"
                            (ngModelChange)="onChangeFeedMultipleNodes($event)">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let nodeFeed of nodeFeeds" value={{nodeFeed}}>
                    {{nodeFeed}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="locationInfoForm.get('mutliNodes').errors?.required">
                  Select Feed Multiple Nodes
                </mat-error>
              </mat-form-field>
            </p>
            <form id="nodesForm" [formGroup]="nodesForm">
              <input type="hidden" formControlName="nodesFormInput" [ngModel]="nodesForm.valid">
              <div formArrayName="node" *ngFor="let node of nodesForms.controls; let i = index;"
                style="display: inline;">
                <mat-form-field style="margin-top: 20px;" class="mat-form-field-infix-class" [formGroupName]="i">
                  <input type="text" (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['node'])" placeholder="Node{{i+2}}" formControlName="node" matInput [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngIf="isLoadingdata" class="is-loading"><mat-spinner diameter="25"></mat-spinner></mat-option>
                    <mat-option *ngFor="let nodeValue of filterNodeOptions[i] | async" [value]="nodeValue.node"
                      (onSelectionChange)="updateFormId(nodeValue, i)">
                      {{nodeValue.node}} / {{nodeValue.nodeCmts}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeError && !validateFN">
                    Select a <strong>Valid</strong> node or <strong>Enable</strong> the Checkbox to remove the Community
                    Restriction !!
                  </mat-error>
                  <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeError && validateFN">
                    Select a <strong>Valid</strong> node !!
                  </mat-error>
                  <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeErrorIdnull && !validateFN">
                    <strong>Enable</strong> the Checkbox to remove the Community Restriction !!
                   </mat-error>

                   <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeErrorIdnull">
                     Please select the node from search dropdown
                   </mat-error>
                   <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.required">
                    Please select a node !!
                  </mat-error>
                </mat-form-field>
              </div>
            </form>

            <mat-form-field class="mat-form-field-infix-class clr">
              <input formControlName="latitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                     [(ngModel)]="locationInfoForm.latitude"
                     (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['latitude'])"
                     (ngModelChange)="onChangeSysLocation()">
              <mat-error *ngIf="locationInfoForm.get('latitude').errors?.required">
                Latitude is <strong>required</strong> !
              </mat-error>
              <mat-error
                *ngIf="locationInfoForm.get('latitude').errors?.validateDecimal && !locationInfoForm.get('latitude').errors?.required">
                Latitude <strong>Must</strong> Be 6-12 Characters After Decimal and Correctly Formatted !
              </mat-error>
              <mat-error
                *ngIf="locationInfoForm.get('latitude').errors?.validateRange && !locationInfoForm.get('latitude').errors?.required">
                {{locationInfoForm.get('latitude').errors?.validateRange}}
              </mat-error>
            </mat-form-field>
            <!-- For design change -->
            <div class="test"
              *ngIf="(locationInfoForm.get('latitude').errors?.validateRange && !locationInfoForm.get('latitude').errors?.required) || (locationInfoForm.get('latitude').errors?.validateDecimal && !locationInfoForm.get('latitude').errors?.required)">
            </div>
            <mat-form-field class="mat-form-field-infix-class clr">
              <input formControlName="longitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                     [(ngModel)]="locationInfoForm.longitude"
                     (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['longitude'])"
                     (ngModelChange)="onChangeSysLocation()">
              <mat-error *ngIf="locationInfoForm.get('longitude').errors?.required">
                Longitude is <strong>required</strong> !
              </mat-error>
              <mat-error
                *ngIf="locationInfoForm.get('longitude').errors?.validateDecimal && !locationInfoForm.get('longitude').errors?.required">
                Longitude <strong>Must</strong> Be 6-12 Characters After Decimal and Correctly Formatted !
              </mat-error>
              <mat-error
                *ngIf="locationInfoForm.get('longitude').errors?.validateRange && !locationInfoForm.get('longitude').errors?.required">
                {{locationInfoForm.get('longitude').errors?.validateRange}}
              </mat-error>
              <span matSuffix class="macButton">
                <a href="https://www.google.com/maps/search/?api=1&query={{locationInfoForm.latitude}},{{locationInfoForm.longitude}}"
                  target='_blank'>
                  <!-- Show on Map -->
                  <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                </a>
              </span>
            </mat-form-field>
            <!-- For design change -->
            <div class="test"
              *ngIf="(locationInfoForm.get('longitude').errors?.validateDecimal && !locationInfoForm.get('longitude').errors?.required) || (locationInfoForm.get('longitude').errors?.validateRange && !locationInfoForm.get('longitude').errors?.required)">
            </div>
            <!-- <mat-form-field class="mat-form-field-infix-class clr">
              <mat-select placeholder="Calculated Runtime" [(ngModel)]="locationInfoForm.estimates"
                formControlName="estimates">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let estimate of estimates" [value]="estimate">
                  {{estimate}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['powerNode'])" placeholder="Calculated Runtime(in Minutes)" formControlName="calculatedRuntime">
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="powerNode" placeholder="Powers Node" [(ngModel)]="locationInfoForm.powerNode"
                          (ngModelChange)="onChangeSysContact()" (ngModelChange)="onChangeSysLocation()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let nodePower of nodePowers" [value]="nodePower">
                  {{nodePower}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationInfoForm.get('powerNode').errors?.required">
                Select Power Node
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['spLocDetails'])" placeholder="Special Location Details" [(ngModel)]="locationInfoForm.spLocDetails"
                (ngModelChange)="onChangeSysLocation()" formControlName="spLocDetails">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="areial" placeholder="Aerial/UG" [(ngModel)]="locationInfoForm.areial">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let UG of UGs" [value]="UG">
                  {{UG}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationInfoForm.get('areial').errors?.required">
                Select Aerial/UG
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['pole'])"  placeholder="Pole#" (ngModelChange)="onChangeSysContact()" formControlName="pole">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="powerCompany" placeholder="Power Company"
                          [(ngModel)]="locationInfoForm.powerCompany" (ngModelChange)="onChangeSysContact()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let powerCompany of powerCompanies" [value]="powerCompany" title="{{powerCompany}}">
                  {{powerCompany}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationInfoForm.get('powerCompany').errors?.required">
                Select Power Company
              </mat-error>
              <span matSuffix class="macButton">
                <a href="{{powerCompanyFinderUrl}}" target='_blank'>
                  <i class="fa fa-search" aria-hidden="true"></i>
                </a>
              </span>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyAccNum'])" placeholder="Power Company Account Number" formControlName="companyAccNum">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyContact'])" placeholder="Power Company Contact Number" formControlName="companyContact">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyWebsite'])" placeholder="Power Company Website" formControlName="companyWebsite">
              <span matSuffix class="macButton">
                <a *ngIf="powerCompanywebsiteUrl" matTooltip="Open Link" href="{{powerCompanywebsiteUrl}}" target='_blank'>Goto link</a>
              </span>
            </mat-form-field>


            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="NWT Team" [(ngModel)]="locationInfoForm.nwtTeam" formControlName="nwtTeam">

                <mat-option>--</mat-option>
                <mat-option *ngFor="let nwtTeam of nwtTeams" [value]="nwtTeam">
                  {{nwtTeam}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['nwtTeam'])" placeholder="NWT Team" formControlName="nwtTeam">
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['nitroCompletionDate'])" placeholder="Nitro Completion Date" formControlName="nitroCompletionDate">
            </mat-form-field>

            <!-- <mat-form-field class="mat-form-field-infix-class">
              <input matInput placeholder="Nitro Reason Not Completed" formControlName="nitroReasonNotCompleted">
            </mat-form-field> -->

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Power Company Account Type" [(ngModel)]="locationInfoForm.powerAccountType"
                formControlName="powerAccountType">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let acctype of acctypes" [value]="acctype">
                  {{acctype}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['meter'])" placeholder="Meter #" formControlName="meter">
              <!-- <mat-error *ngIf="locationInfoForm.get('meter').errors?.required">
                Enter Meter Number
              </mat-error> -->
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['pscreateddate'])" placeholder="PS Created Date" formControlName="pscreateddate">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['mapPageNumber'])" placeholder="Map Page Number ###-###" [(ngModel)]="locationInfoForm.mapPageNumber"
                (ngModelChange)="onChangeSysLocation()" formControlName="mapPageNumber">
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Business Partner Restriction"
                [(ngModel)]="locationInfoForm.businessPartnerRestriction" formControlName="businessPartnerRestriction"
                (ngModelChange)="onChangeSysLocation()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let businessPartnerRestriction of businessPartneRestrictions"
                  [value]="businessPartnerRestriction">
                  {{businessPartnerRestriction}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field style="width:290px;">
            <mat-label>Location Comments</mat-label>
            <textarea matInput rows="3" formControlName="locationComments"></textarea>
            <mat-error *ngIf="locationInfoForm.get('locationComments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
            <mat-error *ngIf="locationInfoForm.get('locationComments').errors?.required">
              Enter Location Comments
            </mat-error>
          </mat-form-field>
          <br><br>
        </div>
      </form>
    </mat-tab>

    <!--Power Supply Tab starts from here-->
    <mat-tab *ngIf="showTransponderEnable==1?false:true">
      <ng-template mat-tab-label>
        <span>Edit Transponder Info</span> &nbsp;
        <div *ngIf="transponderInfoForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <form id="transponderInfoForm" [formGroup]="transponderInfoForm">
        <div align="center">
          <br>
          <!--APU APU Visit Form-->
          <div *ngIf="showApu">
            <!-- <button class="apuButton" mat-raised-button (click)="openApuDialog()">APU Info</button> &nbsp; -->
            <!-- <button class="apuButton" mat-raised-button (click)="openApuVisitDialog()">APU Visit Info</button> &nbsp; -->
            <button class="apuButton" mat-raised-button (click)="openSupplyDialog(2)">Supply #2</button> &nbsp;
            <button class="apuButton" mat-raised-button (click)="openSupplyDialog(3)">Supply #3</button> &nbsp;
            <!-- <button class="apuButton" mat-raised-button (click)="openSupplyDialog(4)">Supply #4</button> &nbsp;
            <button class="apuButton" mat-raised-button (click)="openSupplyDialog(5)">Supply #5</button> &nbsp; -->
            <br>
          </div>
          <div>
            <p>
              <strong>Power Supply Status</strong>
              <br>
              <!-- <span class="macButton" (click)="onClickpsStatus()"> {{linkMacAddress}} </span> -->
              <a *ngIf="psMacLinkEnable==0" target="_blank" class="macButtonnewlink"
                href="/#/telemetry?powerSupplyId={{powerSupplyId}}">
                {{linkMacAddress}} </a>
              <a *ngIf="psMacLinkEnable==2" target="_blank" class="macButtonDisabled">
                {{linkMacAddress}} </a>
            </p>
            <p>
              &nbsp;
              <span class="pstypeIcon">
                <nwt-power-supply-tooltip [powerSupplyType]="selectedPSType"></nwt-power-supply-tooltip>
              </span>


              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="standByOpts" placeholder="StandBy/Non-StandBy"
                            [(ngModel)]="transponderInfoForm.standByOpts" (ngModelChange)="onChangePowerSupplyType()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let standByOption of standByOptions" [value]="standByOption">
                    {{standByOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('standByOpts').errors?.required">
                  Select StandBy/Non-StandBy
                </mat-error>
              </mat-form-field>
              <!-- <mat-form-field class="mat-form-field-infix-class">
                    <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['activeMacAddress'])" placeholder="ActiveMacAddress" formControlName="activeMacAddress"
                      [(ngModel)]="activeMacAddress" (ngModelChange)="onMacChange($event)">

                <span *ngIf="showTransponderEnable != 2" matSuffix class="macButton" (click)="onClickGenerateMac()"><i matSuffix
                    class="fa fa-mouse-pointer"></i>
                  &nbsp; Generate MAC &nbsp; | &nbsp;</span>
                <span *ngIf="showTransponderEnable == 2" matSuffix class="macButtonDisabled"><i matSuffix
                    class="fa fa-mouse-pointer"></i>
                  &nbsp; Generate MAC &nbsp; | &nbsp;</span>
                <span *ngIf="pullTransponderButton && showTransponderEnable != 2" matSuffix class="macButton" (click)="onPullTransponder()"> Pull
                  Transponder Data</span>
                <span *ngIf="pullTransponderButton && showTransponderEnable == 2" matSuffix class="macButtonDisabled"> Pull
                    Transponder Data</span>
                <span *ngIf="!pullTransponderButton" matSuffix class="macButtonDisabled"> Pull Transponder
                  Data</span>
                <mat-error *ngIf="transponderInfoForm.get('activeMacAddress').errors?.required">
                  MAC Address is <strong>required</strong>
                </mat-error>
                <mat-error
                  *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateMac00 && !transponderInfoForm.get('activeMacAddress').errors?.required">
                  Please enter a <strong>valid</strong> MAC or <strong>Select</strong> the Generate MAC Placeholder
                  button !
                </mat-error>
              </mat-form-field> -->
              <mat-form-field class="mat-form-field-infix-class">
                <input formControlName="activeMacAddress" matInput max="17" maxlength="17" min="0"
                       placeholder="ActiveMacAddress" [(ngModel)]="transponderInfoForm.activeMacAddress"
                       [value]="mac_address"
                       (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['activeMacAddress'])"
                       (keydown.space)="$event.preventDefault()" (keypress)="omit_special_char($event)"
                       (ngModelChange)="onMacChange($event)">
                  <span *ngIf="showTransponderEnable != 2" matSuffix class="macButton" (click)="onClickGenerateMac()"><i matSuffix
                    class="fa fa-mouse-pointer"></i>
                  &nbsp; Generate MAC &nbsp; | &nbsp;</span>
                 <span *ngIf="showTransponderEnable == 2" matSuffix class="macButtonDisabled"><i matSuffix
                    class="fa fa-mouse-pointer"></i>
                  &nbsp; Generate MAC &nbsp; | &nbsp;</span>
                <span *ngIf="pullTransponderButton && showTransponderEnable != 2" matSuffix class="macButton" (click)="onPullTransponder()"> Pull
                  Transponder Details</span>
                <span *ngIf="pullTransponderButton && showTransponderEnable == 2" matSuffix class="macButtonDisabled"> Pull
                    Transponder Details</span>
                <span *ngIf="!pullTransponderButton" matSuffix class="macButtonDisabled"> Pull Transponder
                  Details</span>
                <mat-error *ngIf="transponderInfoForm.get('activeMacAddress').errors?.required">
                  MAC Address is <strong>required</strong>
                </mat-error>
                <mat-error
                  *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateMac && !transponderInfoForm.get('activeMacAddress').errors?.required">
                  MAC Address Format is <strong>Invalid</strong> !
                </mat-error>
                <mat-error
                  *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateMac00 && !transponderInfoForm.get('activeMacAddress').errors?.required">
                  Please enter a <strong>valid</strong> MAC or <strong>Select</strong> the Generate MAC Placeholder
                  button !
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <input [disabled]="true" matInput  placeholder="Previous MAC Address" formControlName="prevMacAddress">
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="mat-form-field-infix-class">
                <input formControlName="ip" matInput placeholder="IP"
                       (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['ip'])">
                <!-- <b *ngIf="showTransponderEnable != 2" matSuffix class="macButton" (click)="onClickGenerateIP()"><i matSuffix
                    class="fa fa-mouse-pointer"></i>
                  &nbsp; Get IP of MAC Address
                </b>
                <b *ngIf="showTransponderEnable == 2" matSuffix class="macButtonDisabled"><i matSuffix
                  class="fa fa-mouse-pointer"></i>
                &nbsp; Get IP of MAC Address
              </b> -->
                <mat-error *ngIf="transponderInfoForm.get('ip').errors?.required">
                  IP is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" *ngIf="showPSNumberSelect">
                <mat-select formControlName="powerSupplyNum" placeholder="Power Supply Number"
                            [(ngModel)]="transponderInfoForm.powerSupplyNum" (ngModelChange)="onChangePowerSupplyNum()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let PSNOption of PSNOptions" [value]="PSNOption">
                    {{PSNOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.required">
                  Select Power Supply Number
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" *ngIf="showPSNumberInput">
                <input formControlName="powerSupplyNum" matInput placeholder="Power Supply Number"
                       (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['powerSupplyNum'])"
                       (ngModelChange)="onChangePowerSupplyNum()">
                <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.required">
                  Power Supply Number is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.validatePSNum
                && !transponderInfoForm.get('powerSupplyNum').errors?.required">
                  Power Supply Number <strong>Should</strong> be 3-5 Characters
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select (ngModelChange)="onChangeNextgenType()" placeholder="Next Gen Node" [(ngModel)]="transponderInfoForm.nextGenNode"
                  formControlName="nextGenNode">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let nextGenOption of nextGenOptions" [value]="nextGenOption">
                    {{nextGenOption}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </p>
            <div *ngIf="showsfp">
              <button class="apuButton" mat-raised-button (click)="openSupplyDialogsfp()">SFP Details</button> &nbsp;
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput
                       formControlName="sfpMac"
                       placeholder="MacAddress as Printed on the SFP"
                       [(ngModel)]="transponderInfoForm.sfpMac"
                       [disabled]="true"
                       [value]="sfpMAC">
              </mat-form-field>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="transponderVendor" placeholder="Transponder Vendor"
                          [(ngModel)]="transponderInfoForm.transponderVendor"
                          (selectionChange)="changePowerSupplyModel($event)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let transponderVendor of transponderVendors" [value]="transponderVendor">
                  {{transponderVendor}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('transponderVendor').errors?.required">
                Select Transponder Vendor
              </mat-error>
              <mat-error *ngIf="transponderInfoForm.get('transponderVendor').errors?.validateVendorType">
                Transponder Vendor <strong>Should</strong> be AM Communications
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="transponderModel" placeholder="Transponder Model"
                          [(ngModel)]="transponderInfoForm.transponderModel"
                          (selectionChange)="changePowerSupplyModelValidation()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let transponderModel of transponderModels" [value]="transponderModel">
                  {{transponderModel}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('transponderModel').errors?.required">
                Select Transponder Model
              </mat-error>
            </mat-form-field>

            <div *ngIf="showPowerSupplyModel">
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="powerSupplyModel" placeholder="PowerSupply Model *"
                            [(ngModel)]="transponderInfoForm.powerSupplyModel"
                            (selectionChange)="changePowerSupplyModelValidation()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let powerSupplyModel of powerSupplyModels" [value]="powerSupplyModel">
                    {{powerSupplyModel}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('powerSupplyModel').errors?.validatePowerSupplyModel">
                  Select PowerSupply Model
                </mat-error>
              </mat-form-field>
            </div>

            <div *ngIf="showPowerSupplyType9360">
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="powerSupplyType9360" placeholder="PowerSupply Type (9360 Model)"
                            [(ngModel)]="transponderInfoForm.powerSupplyType9360">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let powerSupplyType9360 of powerSupplyTypes" [value]="powerSupplyType9360">
                    {{powerSupplyType9360.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('powerSupplyType9360').errors?.validatePowerSupply9360">
                  Select PowerSupply Type (9360 Model)
                </mat-error>
              </mat-form-field>
            </div>

            <p>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="acInputVoltage" placeholder="AC Input Voltage Rating"
                            [(ngModel)]="transponderInfoForm.acInputVoltage" (ngModelChange)="changePSAlertProfile()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let inputVoltageRating of inputVoltageRatings" [value]="inputVoltageRating">
                    {{inputVoltageRating}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('acInputVoltage').errors?.required || transponderInfoForm.get('acInputVoltage').errors?.validateacInputVoltage">
                  Select AC Input Voltage Rating
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="acOutputVoltage" placeholder="AC Output Voltage Rating"
                            [(ngModel)]="transponderInfoForm.acOutputVoltage" (ngModelChange)="changePSAlertProfile()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let outputVoltageRating of outputVoltageRatings" [value]="outputVoltageRating">
                    {{outputVoltageRating}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('acOutputVoltage').errors?.required || transponderInfoForm.get('acOutputVoltage').errors?.validateacOutputVoltage">
                  Select AC Output Voltage Rating
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="currentAmp" placeholder="Current Amp Rating"
                            [(ngModel)]="transponderInfoForm.currentAmp" (ngModelChange)="changePSAlertProfile()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let ampRating of ampRatings" [value]="ampRating">
                    {{ampRating}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('currentAmp').errors?.required || transponderInfoForm.get('currentAmp').errors?.validatecurrentAmp(ampRatings)">
                  Select Current Amp Rating
                </mat-error>
              </mat-form-field>

              <!-- <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Current (Amp Output) Rating"
                [(ngModel)]="transponderInfoForm.currentAmpOutput" (ngModelChange)="changePSAlertProfile()"
                  formControlName="currentAmpOutput">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let ampOutputRating of ampOutputRatings" [value]="ampOutputRating">
                    {{ampOutputRating}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('currentAmpOutput').errors?.required || transponderInfoForm.get('currentAmpOutput').errors?.validatecurrentAmpOutput">
                  Select Current (Amp Output) Rating
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['powerSupplyAlertProfile'])" placeholder="Power Supply Alert Profile" [value]=powerSupplyAlertProfile
                  formControlName="powerSupplyAlertProfile">
              </mat-form-field>
            </p>

            <p>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['serialNum'])" placeholder="Serial Number" formControlName="serialNum">
              </mat-form-field>

              <!-- <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Controlled Card Type" [(ngModel)]="transponderInfoForm.controlledCardType"
                  formControlName="controlledCardType">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let cardType of cardTypes" [value]="cardType">
                    {{cardType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="transponderInfoForm.get('controlledCardType').errors?.required">
                  Select Controlled card type
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="DC Ready?" [(ngModel)]="transponderInfoForm.dcReady" formControlName="dcReady">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let DCReadyDecision of DCReadyDecisions" [value]="DCReadyDecision">
                    {{DCReadyDecision}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['priority'])" placeholder="Priority" formControlName="priority"
                  (ngModelChange)="onChangeSysLocation()">
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['egisName'])" placeholder="EGIS Number" formControlName="egisName">
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['egisName'])" placeholder="EGIS Number" formControlName="egisName">
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['globalidentifier'])" placeholder="Global Identifier" [(ngModel)]="transponderInfoForm.globalidentifier"
                  formControlName="globalidentifier">
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="externalSensor" placeholder="Ethernet Connected Device" [(ngModel)]="transponderInfoForm.externalSensor">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let externalSensorData of externalSensors" [value]="externalSensorData">
                    {{externalSensorData}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </p>
          </div>
          <mat-form-field style="width:290px;">
            <mat-label>Transponder Comments</mat-label>
            <textarea matInput rows="3" formControlName="transponderComments"></textarea>
            <mat-error *ngIf="transponderInfoForm.get('transponderComments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
          </mat-form-field>
          <br><br>
        </div>
      </form>
    </mat-tab>


    <mat-tab *ngIf="apuTab">
      <ng-template mat-tab-label>
        <span>Add APU Info</span> &nbsp;
        <div *ngIf="apuFormGroup.invalid || apuFormGroup.invalid || apuFormGroup.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <br>
      <!-- <mat-dialog-content class="mat-typography" align="center"> -->
        <div align="center">
          <form id="apuFormGroup" [formGroup]="apuFormGroup">
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="APU - Make Model" formControlName="apuMakeModel">
                <mat-option *ngFor="let apuMakeModel of apuMakeModels" [value]="apuMakeModel.description">
                  {{apuMakeModel.description}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('apuMakeModel').errors?.required">
                Select APU - Make Model
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['apuSerialNumber'])" placeholder="APU Serial Number" formControlName="apuSerialNumber">
              <mat-error *ngIf="apuFormGroup.get('apuSerialNumber').errors?.required">
                APU Serial Number is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="APU Device Id" formControlName="apuDeviceId">
                <mat-option *ngFor="let deviceId of deviceIds" [value]="deviceId">
                  {{deviceId}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('apuDeviceId').errors?.required">
                Select APU Device Id
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['apuRunTime'])" placeholder="APU Runtime" formControlName="apuRunTime">
              <mat-error *ngIf="apuFormGroup.get('apuRunTime').errors?.required">
                APU Runtime is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="ECM/ACM" formControlName="ecmAcm">
                <mat-option *ngFor="let ecmAcm of ecmAcms" [value]="ecmAcm">
                  {{ecmAcm}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('ecmAcm').errors?.required">
                Select ECM/ACM
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['dateApuInstalled'])" [matDatepicker]="picker" placeholder="Date APU Installed" formControlName="dateApuInstalled">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="apuFormGroup.get('dateApuInstalled').errors?.required">
                Date APU Installed is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="APU Output Voltage Rating" formControlName="apuOpVltgRating">
                <mat-option *ngFor="let apuOpVltgRating of apuOpVltgRatings" [value]="apuOpVltgRating">
                  {{apuOpVltgRating}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('apuOpVltgRating').errors?.required">
                Select APU Output Voltage Rating
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['apuNoLoadVltg'])" placeholder="APU No-Load Voltage" (keypress)="numberOnly($event)" formControlName="apuNoLoadVltg">
              <mat-error *ngIf="apuFormGroup.get('apuNoLoadVltg').errors?.validateNumber">
                APU No-Load Voltage <strong>Should</strong> only include numbers !!
              </mat-error>
              <mat-error *ngIf="apuFormGroup.get('apuNoLoadVltg').errors?.required">
                APU No-Load Voltage is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['apuLoadVltg'])" placeholder="APU Load Voltage" (keypress)="numberOnly($event)" formControlName="apuLoadVltg">
              <mat-error *ngIf="apuFormGroup.get('apuLoadVltg').errors?.validateNumber">
                APU Load Voltage <strong>Should</strong> only include numbers !!
              </mat-error>
              <mat-error *ngIf="apuFormGroup.get('apuLoadVltg').errors?.required">
                APU Load Voltage is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="APU Enclosure - Make/Model" formControlName="apuEnclosure">
                <mat-option *ngFor="let apuEnclosure of apuEnclosures" [value]="apuEnclosure">
                  {{apuEnclosure}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('apuEnclosure').errors?.required">
                Select APU Enclosure - Make/Model
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="NG/LP" formControlName="ngLp">
                <mat-option *ngFor="let ngLp of ngLps" [value]="ngLp">
                  {{ngLp}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('apuEnclosure').errors?.required">
                Select NG/LP
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="NG Provider(If used)" formControlName="ngProvider">
                <mat-option *ngFor="let ngProvider of ngProvideres" [value]="ngProvider.naturalGasProvider1">
                  {{ngProvider.naturalGasProvider1}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="apuFormGroup.get('ngProvider').errors?.required">
                Select NG Provider(If used)
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['lpTankCapacity'])" placeholder="LP Tank Capacity" formControlName="lpTankCapacity">
              <mat-error *ngIf="apuFormGroup.get('lpTankCapacity').errors?.required">
                LP Tank Capacity is required !
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(apuFormGroup.controls['noOfTanksInstalled'])" placeholder="Number Of Tanks Installed" (keypress)="numberOnly($event)" formControlName="noOfTanksInstalled">
              <mat-error *ngIf="apuFormGroup.get('noOfTanksInstalled').errors?.validateNumber">
                Number Of Tanks Installed <strong>Should</strong> only include numbers !!
              </mat-error>
              <mat-error *ngIf="apuFormGroup.get('noOfTanksInstalled').errors?.required">
                Number Of Tanks Installed is required !
              </mat-error>
            </mat-form-field>
          </form>
        </div>
      <!-- </mat-dialog-content> -->
    </mat-tab>

    <!--Battery Info Tab starts from here-->
    <mat-tab *ngIf="showBatteryEnable==1?false:true">
      <ng-template mat-tab-label>
        <span>Edit Battery Info</span> &nbsp;
        <div *ngIf="batteryInfoForm.invalid || batteryStringForm.invalid || batteryBatteryForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <form id="batteryInfoForm" [formGroup]="batteryInfoForm">
        <div align="center">
          <br>
          <h5 style="color: coral">Battery Info</h5>
          <div>
            <!-- <p> -->
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="numberofBatteries" placeholder="Number Of Batteries"
                            [(ngModel)]="batteryInfoForm.numberofBatteries"
                            (ngModelChange)="onChangeNumberOfBatteries()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteries of numberofBatteries" [value]="batteries">
                    {{batteries}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="batteryInfoForm.get('numberofBatteries').errors?.required">
                  Select Number Of Batteries
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="batteriesReplaced" placeholder="Were The Batteries Replaced(Yes or No)?"
                            [(ngModel)]="batteryInfoForm.batteriesReplaced" (ngModelChange)="onChangeBatteriesReplaced()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteries of batteriesReplaced" [value]="batteries">
                    {{batteries}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="batteryInfoForm.get('batteriesReplaced').errors?.required">
                  Select Were The Batteries Replaced
                </mat-error>
              </mat-form-field>

              <!-- <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['airTemperature'])" placeholder="Air Temperature" formControlName="airTemperature">
              </mat-form-field> -->
            <!-- </p> -->
             <div class="col">
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="batteryManagerModel" placeholder="Battery Manager Model">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryManagerModel of batteryManagerModels" [value]="batteryManagerModel">
                    {{batteryManagerModel}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="batteryInfoForm.get('batteryManagerModel').errors?.required">
                  Select Battery Manager Model
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <form id="batteryStringForm" [formGroup]="batteryStringForm">
        <div align="center" style="margin: 0 0 0 -10px;">
          <div formArrayName="batteryString" *ngFor="let node of batteryStringForms.controls; let i = index;"
            class="container">
            <!-- <small style="color: coral">String {{i+1}}</small> -->
            <div class="row" *ngIf="i==0">
              <!-- <div class="col">
                <mat-form-field class="mat-form-field-infix-class" [formGroupName]="i">
                  <mat-select placeholder="Battery Manager Model ( String {{i+1}} )" (selectionChange)="clearValidationOnChange($event)" [(ngModel)]="node[i]"
                    formControlName="batteryManagerModel">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let batteryManagerModel of batteryManagerModels" [value]="batteryManagerModel">
                      {{batteryManagerModel}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="batteryStringForms.controls[i].get('batteryManagerModel').errors?.required">
                    Select Battery Manager Model( String {{i+1}})
                  </mat-error>
                </mat-form-field>
              </div> -->

              <!-- <div class="col">
                <mat-form-field class="mat-form-field-infix-class" [formGroupName]="i">
                  <mat-select placeholder="Battery Separator Present" formControlName="batterySeparator">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let batterySeparator of batterySeparatorPresent" [value]="batterySeparator">
                      {{batterySeparator}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            </div>

            <!-- ........................................... -->
            <form id="batteryBatteryForm" [formGroup]="batteryBatteryForm">
              <div formArrayName="batteryBatteries" *ngFor="let node of batteryBatteryForms.controls; let j = index;"
                style="display: inline-block;">
                <div *ngIf="IsTrue(i, j)">
                  <mat-card class="example-card" style="margin:1em;">
                    <mat-card-header>
                      <mat-card-title *ngIf="!parallelBatt && lionBatt">String 1 - Battery - 1</mat-card-title>
                      <mat-card-title *ngIf="!parallelBatt && !lionBatt">String {{i+1}} - Battery - {{getBatteryNumber(j)}}</mat-card-title>
                      <mat-card-title *ngIf="parallelBatt && !lionBatt">String {{i+1}} - Parallel Battery - {{getBatteryNumber(j)}}</mat-card-title>
                      <!-- <button *ngIf="getBatteryNumber(j) == 1" [disabled]="this.showBatteryEnable==2"
                        matTooltip="Clone data to other batteries" mat-mini-fab
                        style="background-color: transparent;color: black;margin-left: 37%" class="fa fa-clone fa-1x" aria-hidden="true"
                        (click)="onClone()"></button> -->
                        <button [disabled]="this.showBatteryEnable==2"
                        matTooltip="QR Scan" mat-mini-fab
                        style="background-color: transparent;color: black;margin-left: 37%" class="fa fa-qrcode fa-2x" aria-hidden="true"
                        (click)="enableScanner(j)"></button>
                    </mat-card-header>
                    <div class="scanner-container">
                    <!--QR Scan Code-->
                      <zxing-scanner #scanner
                                     *ngIf="scannerEnabled[j]"
                                     id="qr-reader" 
                                     [zoom]="zoom" 
                                     (scanSuccess)="scanSuccessHandler($event,j)">
                      </zxing-scanner>
                      <div *ngIf="zoomFlag[j]" class="focus-frame"></div>
                      <div *ngIf="zoomFlag[j]" class="mt-5">
                        <i aria-hidden="true" class="fa fa-search-plus zoom-icon" (click)="zoomIn()">
                          <b class="zoom-text">ZoomIn</b>
                        </i>
                        <i aria-hidden="true" class="fa fa-search-minus zoom-icon" (click)="zoomOut()">
                          <b class="zoom-text">ZoomOut</b>
                        </i>
                      </div>
                    </div>
                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <mat-select placeholder="Battery Manufacturer/Type {{asterisk}}" [(ngModel)]="node[j]"
                          formControlName="batteryManufacturer" ngDefaultControl>
                          <mat-option>--</mat-option>
                          <mat-option *ngFor="let batteryManufacturer of batteryManufactureres"
                            [value]="batteryManufacturer">
                            {{batteryManufacturer}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryManufacturer').errors?.required">
                          Select Battery Manufacturer
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batterySerial'])" placeholder="Battery Serial Number {{asterisk}}"
                          formControlName="batterySerial">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batterySerial').errors?.required">
                          Battery Serial Number is <strong>required</strong>
                        </mat-error>
                        <mat-error
                          *ngIf="batteryBatteryForms.controls[j].get('batterySerial').errors?.validateBatteryDateCode">
                          <strong>Incorrect</strong> Date Format (MMYY)
                        </mat-error>
                       </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryCode'])" placeholder="Battery Date Code (On Battery) {{asterisk}}"
                          formControlName="batteryCode">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryCode').errors?.required">
                          Battery Date Code is <strong>required</strong>
                        </mat-error>
                        <mat-error
                          *ngIf="batteryBatteryForms.controls[j].get('batteryCode').errors?.validateBatteryDateCode">
                          <strong>Incorrect</strong> Date Format (MMYY)
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryInstallDate'])" [matDatepicker]="picker" placeholder="Battery Install Date {{asterisk}}"
                          formControlName="batteryInstallDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryInstallDate').errors?.required">
                          Battery Install Date is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryVoltageNoLoad'])" placeholder="Battery Voltage - No Load {{asterisk}}"
                          formControlName="batteryVoltageNoLoad">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryVoltageNoLoad').errors?.required">
                          Battery Voltage - No Load is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryVoltageUnderLoad'])" placeholder="Battery Voltage - Under Load (After 9 Minute Self-Test)"
                          formControlName="batteryVoltageUnderLoad">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryConductance'])"  placeholder="Battery Conductance (mhos)" formControlName="batteryConductance">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['batteryConductanceCorrected'])" placeholder="Battery Conductance - Corrected to 77deg F"
                          formControlName="batteryConductanceCorrected">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryBatteryForms.controls['totalVoltage'])" placeholder="Total Voltage String {{i+1}} - No load (VDC)"
                          formControlName="totalVoltage">
                      </mat-form-field>
                    </p>
                  </mat-card>
                </div>
              </div>
            </form>
          </div>
        </div>
      </form>
      <br>
      <form [formGroup]="batteryInfoForm">
        <div align="center">
          <div>
            <mat-form-field style="width:290px;">
              <mat-label>Battery Comments</mat-label>
              <textarea matInput rows="3" formControlName="batteryComments"></textarea>
              <mat-error *ngIf="batteryInfoForm.get('batteryComments').errors?.maxlength">
                Comments can <strong>Maximum</strong> 255 Characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
      <br>
    </mat-tab>

    <!--Last Visit Info tab starts from here-->
    <mat-tab *ngIf="showLastVisitEnable==1?false:true">
      <ng-template mat-tab-label>
        <span>Edit Last Visit Info</span> &nbsp;
        <div *ngIf="lastVisitInfoForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
        <form id="lastVisitInfoForm" [formGroup]="lastVisitInfoForm">
            <div align="center">
              <!-- <div *ngIf="certRequiredValue">
                <mat-card ngDefaultControl formControlName="selftest" style="max-width:365px;margin:10px 5% 0 5%;background-color:#e9e5e5;padding:0px">
                   <button (click) = refresh(); mat-icon-button>
                      <i style="cursor:pointer;font-size: 24px;" class="fa fa-refresh {{refreshSpin}} "></i>
                   </button>
                      Last Remote Test:<b>{{lastRunDate}}</b><br>
                      Last Run Status:<b>{{telemetryinverter}}</b><br>
                      Inverter Status: <b>{{telemetryinverterStatus}}</b>&nbsp;&nbsp;&nbsp;
                   <button matTooltip="Remote Self Test Start" [disabled]="showProgressBar || this.refreshSpin == 'fa-spin' ||showProgressBarRefresh || manualdisabled" (click)="remotetest()" style="height:26px;width:40px;">
                      <i style="cursor:pointer;font-size:20px;" class="fa fa-play-circle"></i>
                   </button>
                   <mat-error *ngIf="lastVisitInfoForm.get('selftest').errors?.required && certRequiredValue && telemetryinverterStatus != 'OFFLINE'">
                       * Self Test is required
                   </mat-error>
                   <mat-error *ngIf="lastVisitInfoForm.get('selftestrunning').errors?.required && certRequiredValue && telemetryinverterStatus != 'OFFLINE'">
                       Self Test is Running.Please Wait ...
                   </mat-error>
                </mat-card><br>
              </div> -->
                <div style="padding:0;margin:10px 5% -20px 5%" ><b>Tech</b><br>
                    {{ (triageLogNt) ? triageLogNt : userName}}
                </div><br>
                <div class=""  *ngIf="certificateFlag">
                  <button type="button" matTooltip="Add/Edit Work Items" class="btn btn-primary textsize" (click)="openAddEntryDialog('Edit')">Add/Edit Work Items</button>
                  <mat-error style="font-size: 14px;" *ngIf="lastVisitInfoForm.get('workitem').errors?.required">
                    Work Items required
                  </mat-error>
                </div>
                <div *ngIf="showProgressBarRefresh">
                    <div class="lmask"></div>
                </div>
                <div>
            <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['inspectionDate'])" [matDatepicker]="picker" placeholder="Inspection Date {{asterisk}}" [value]="inspectionDateValue"
                formControlName="inspectionDate" readonly="readonly" (dateChange)="onChangeinspection(maintDialog,mainDialogueReturnvisit)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="lastVisitInfoForm.get('inspectionDate').errors?.required">
                  Inspection Date is required
                </mat-error>
              </mat-form-field>
              <mat-checkbox class="ins_date" (change)='onChangeIns($event)'>Today</mat-checkbox>&nbsp;

              <mat-form-field *ngIf="this.permissionValue==false" class="mat-form-field-infix-class"
                              hideRequiredMarker="true" style="margin: 20px;">
                <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                  formControlName="typeOfVisit" (ngModelChange)="onChangevisitType();onChangevisit()" (selectionChange)="onUserSelectVisitType()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let visitType of visitTypesbp" [value]="visitType">
                    {{visitType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                  Select Type Of Visit
                </mat-error>
              </mat-form-field>
              <mat-form-field *ngIf="this.permissionValue==true" class="mat-form-field-infix-class"
                              hideRequiredMarker="true" style="margin: 20px;">
                <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                  formControlName="typeOfVisit" (selectionChange)="onChangevisit();onUserSelectVisitType()" (ngModelChange)="onChangevisitType()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let visitType of visitTypesinhouse" [value]="visitType">
                    {{visitType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                  Select Type Of Visit
                </mat-error>
              </mat-form-field>
                <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                    <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                                formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let visitType of visitTypes" [value]="visitType">
                            {{visitType}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                        Select Type Of Visit
                    </mat-error>
                </mat-form-field> -->



              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Visit Status" [(ngModel)]="lastVisitInfoForm.visitStatus"
                  (ngModelChange)="onChangevisitStatus()" formControlName="visitStatus">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let visitStatus of visitStatusvalue" [value]="visitStatus">
                    {{visitStatus}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('visitStatus').errors?.required">
                  Select Visit Status
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field *ngIf="!permissionValue" class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['mobileno'])" maxlength="12" autocomplete="off" (keypress)="mobilenopattern($event)" formControlName="mobileno" placeholder="Phone No">
                <mat-error *ngIf="lastVisitInfoForm.get('mobileno').errors?.required">
                  Phone No is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Follow Up Reason" [(ngModel)]="lastVisitInfoForm.followUpReasons"
                  (ngModelChange)="onfollowUpReasons();onChangefollowup();" formControlName="followUpReasons">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let followUpReason of followUpReasons" [value]="followUpReason">
                    {{followUpReason}}
                  </mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="lastVisitInfoForm.get('followUpReasons').errors?.required">
                  Select Follow Up Reason
                </mat-error> -->
              </mat-form-field>

              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="XOC Verified Transponder Operational {{asterisk}}"
                  [(ngModel)]="lastVisitInfoForm.xocVerified" formControlName="xocVerified">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let XOCTransponderVerification of XOCTransponderVerifications"
                    [value]="XOCTransponderVerification">
                    {{XOCTransponderVerification}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('xocVerified').errors?.required">
                  Select XOC Verified Transponder Operational
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Clean Dust And Dirt From Enclosure {{asterisk}}"
                  [(ngModel)]="lastVisitInfoForm.cleanDust" formControlName="cleanDust">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let cleanDustOption of CleanDustDirtFromEnclosure" [value]="cleanDustOption">
                    {{cleanDustOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('cleanDust').errors?.required">
                  Select Clean Dust And Dirt From Enclosure
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Meter Pan Condition {{asterisk}}" [(ngModel)]="lastVisitInfoForm.meterPan"
                  formControlName="meterPan">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let meterPanCondition of MeterPanCondition" [value]="meterPanCondition">
                    {{meterPanCondition}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('meterPan').errors?.required">
                  Select Meter Pan Condition
                </mat-error>
              </mat-form-field>
            </p>

            <p>
              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Tighten All Enclosure Hardware {{asterisk}}" [(ngModel)]="lastVisitInfoForm.tightenAll"
                formControlName="tightenAll">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let hardwareTightenOption of TightenAllEnclosureHardwares"
                    [value]="hardwareTightenOption">
                    {{hardwareTightenOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('tightenAll').errors?.required">
                  Select Tighten All Enclosure Hardware
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Inspect Wire Harnesses And Connectors {{asterisk}}"
                  [(ngModel)]="lastVisitInfoForm.inspectWire" formControlName="inspectWire">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let wireInspection of InspectWireHarnessesConnectors" [value]="wireInspection">
                    {{wireInspection}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('inspectWire').errors?.required">
                  Select Inspect Wire Harnesses And Connectors
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Inspect Battery Temperature Probes {{asterisk}}"
                  [(ngModel)]="lastVisitInfoForm.inspectBattery" formControlName="inspectBattery">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryTemperatureInspectionOption of InspectBatteryTemperatureProbes"
                    [value]="batteryTemperatureInspectionOption">
                    {{batteryTemperatureInspectionOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('inspectBattery').errors?.required">
                  Select Inspect Battery Temperature Probes
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class" appearance="outline">
                <mat-label>Comments(optional)</mat-label>
                <textarea matInput rows="3" formControlName="lastVisitComments"></textarea>
                <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.maxlength">
                  Comments can <strong>Maximum</strong> 255 Characters
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['receptacleType'])" placeholder="Receptacle Type {{asterisk}}" formControlName="receptacleType">
                <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                  Receptacle Type is required
                </mat-error>
              </mat-form-field>
              <!-- <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Receptacle Type</span><br>
                  <mat-radio-group formControlName="receptacleType" [(ngModel)]="lastVisitInfoForm.receptacleType">
                    <mat-radio-button class="mar-right" value="120">120</mat-radio-button>
                    <mat-radio-button class="mar-right" value="240">240</mat-radio-button>
                    <mat-radio-button class="mar-right" value="both">Both</mat-radio-button>
                  </mat-radio-group>
                </span>
                <input matInput placeholder="" style="display: none;" formControlName="receptacleType">
                <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                  Receptacle Type is required
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Cabinet Vendor</span><br><br>
                  <mat-radio-group formControlName="cabinetVendor" [(ngModel)]="lastVisitInfoForm.cabinetVendor">
                    <mat-radio-button class="mar-right" *ngFor="let cabinetVendor of cabinetVendors"
                      [value]="cabinetVendor">{{cabinetVendor}}</mat-radio-button>
                  </mat-radio-group>
                </span>
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cabinetVendor'])" placeholder="" style="display: none;" formControlName="cabinetVendor">
                <mat-error *ngIf="lastVisitInfoForm.get('cabinetVendor').errors?.required">
                  Cabinet Vendor is required
                </mat-error>
              </mat-form-field>

            </p>

            <!-- <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Power Co Riser Condition {{asterisk}}" [(ngModel)]="lastVisitInfoForm.powerCo"
                  formControlName="powerCo">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let coRiserCondition of coRiserCondition" [value]="coRiserCondition">
                    {{coRiserCondition}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('powerCo').errors?.required">
                  Select Power Co Riser Condition
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Battery Heater Mat Type {{asterisk}}" [(ngModel)]="lastVisitInfoForm.batteryHeaterType"
                formControlName="batteryHeaterType">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryHeaterMatType of batteryHeaterMatTypes" [value]="batteryHeaterMatType">
                    {{batteryHeaterMatType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryHeaterType').errors?.required">
                  Select Battery Heater Mat Type
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput placeholder="Battery Heater Mat Quantity {{asterisk}}" formControlName="batteryHeaterQuantity">
                <mat-error *ngIf="lastVisitInfoForm.get('batteryHeaterQuantity').errors?.required">
                  Select Battery Heater Mat Quantity
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Enclosure Snow Shield {{asterisk}}" [(ngModel)]="lastVisitInfoForm.encloseSnow"
                  formControlName="encloseSnow">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let snowSheildOption of snowSheildOptionss" [value]="snowSheildOption">
                    {{snowSheildOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('encloseSnow').errors?.required">
                  Select Enclosure Snow Shield
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput placeholder="Internal Breaker {{asterisk}}" formControlName="internalBreaker">
                <mat-error *ngIf="lastVisitInfoForm.get('internalBreaker').errors?.required">
                  Internal Breaker is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput placeholder="Service Entrance {{asterisk}}" formControlName="serviceEntrance">
                <mat-error *ngIf="lastVisitInfoForm.get('serviceEntrance').errors?.required">
                  Service Entrance is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <input matInput placeholder="Receptacle Type {{asterisk}}" formControlName="receptacleType">
                <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                  Receptacle Type is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check Seizure Screw / Alt Box {{asterisk}}" [(ngModel)]="lastVisitInfoForm.checkSeizure"
                formControlName="checkSeizure">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let seizureScrew of seizureScres" [value]="seizureScrew">
                    {{seizureScrew}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkSeizure').errors?.required">
                  Select Check Seizure Screw / Alt Box
                </mat-error>
              </mat-form-field>
            </p>

            <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Is Power Supply ID Legible {{asterisk}}" [(ngModel)]="lastVisitInfoForm.psIDLegibile"
                formControlName="psIDLegibile">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let powerSupplyIDLegibility of powerSupplyIDLegibilitis"
                    [value]="powerSupplyIDLegibility">
                    {{powerSupplyIDLegibility}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('psIDLegibile').errors?.required">
                  Select Is Power Supply ID Legible
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check Lamps & LEDs {{asterisk}}" [(ngModel)]="lastVisitInfoForm.checkLamps"
                  formControlName="checkLamps">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let lampCheckOption of lampCheckOptionValues" [value]="lampCheckOption">
                    {{lampCheckOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkLamps').errors?.required">
                  Select check Lamps & LEDs
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check For 20 Amp Hi-Magnetic Circuit Breaker {{asterisk}}"
                  [(ngModel)]="lastVisitInfoForm.checkCircuitBreaker" formControlName="checkCircuitBreaker">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let checkCircuitBreakOption of checkCircuitBreakOptionValues"
                    [value]="checkCircuitBreakOption">
                    {{checkCircuitBreakOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkCircuitBreaker').errors?.required">
                  Select Check For 20 Amp Hi-Magnetic Circuit Breaker
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Visual Inspection Of Cabinet {{asterisk}}" [(ngModel)]="lastVisitInfoForm.visualInspection"
                formControlName="visualInspection">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let cabinetInspection of cabinetInspectionvalues" [value]="cabinetInspection">
                    {{cabinetInspection}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('visualInspection').errors?.required">
                  Select Visual Inspection Of Cabinet
                </mat-error>
              </mat-form-field>
            </p>

            <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Cabinet Locked {{asterisk}}" [(ngModel)]="lastVisitInfoForm.cabinetLocked"
                  formControlName="cabinetLocked">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let cabinetLockOption of cabinetLockOptionvalues" [value]="cabinetLockOption">
                    {{cabinetLockOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('cabinetLocked').errors?.required">
                  Select Cabinet Locked
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Security Bar Present {{asterisk}}" [(ngModel)]="lastVisitInfoForm.securityBar"
                  formControlName="securityBar">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let securityBarOption of securityBarOptionvalues" [value]="securityBarOption">
                    {{securityBarOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('securityBar').errors?.required">
                  Select Security Bar Present
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check Ground Connection At Cabinet {{asterisk}}" [(ngModel)]="lastVisitInfoForm.checkGround"
                formControlName="checkGround">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let checkGroundConnection of checkGroundConnectionvalues"
                    [value]="checkGroundConnection">
                    {{checkGroundConnection}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkGround').errors?.required">
                  Select Check Ground Connection At Cabinet
                </mat-error>
              </mat-form-field>
            </p> -->

            <!-- <div *ngFor="let batteryStringFused of noOfBatteriesFused; let i = index" style="display: inline;">
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Battery String # {{i+1}} - Fused {{asterisk}}" [(ngModel)]="batteryStringFused[i]"
                formControlName="batteryStringFused{{i+1}}">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryStringFuse of batteryStringFuses" [value]="batteryStringFuse">
                    {{batteryStringFuse}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused1').errors?.required && i == 0">
                  Select Battery String #1 - Fused
                </mat-error>
                <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused2').errors?.required && i == 1">
                  Select Battery String #2 - Fused
                </mat-error>
                <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused3').errors?.required && i == 2">
                  Select Battery String #3 - Fused
                </mat-error>
                <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused4').errors?.required && i == 3">
                  Select Battery String #4 - Fused
                </mat-error>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused5').errors?.required && i == 4">
                  Select Battery String #5 - Fused
                </mat-error>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused6').errors?.required && i == 5">
                  Select Battery String #6 - Fused
                </mat-error>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused5').errors?.required && i == 4">
                  Select Battery String #5 - Fused
                </mat-error>
                <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused6').errors?.required && i == 5">
                  Select Battery String #6 - Fused
                </mat-error>
              </mat-form-field>
            </div>
            <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
              <mat-select placeholder="Tamper Installed And Functioning {{asterisk}}" [(ngModel)]="lastVisitInfoForm.tamperInstalled"
              formControlName="tamperInstalled">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let tamperInstalledOption of tamperInstalledvalue" [value]="tamperInstalledOption">
                  {{tamperInstalledOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('tamperInstalled').errors?.required">
                Select Tamper Installed And Functioning
              </mat-error>
            </mat-form-field> -->

            <p>
              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check LAP's {{asterisk}}" [(ngModel)]="lastVisitInfoForm.checkLaps"
                  formControlName="checkLaps">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let checkLAP of checkLAPsvalue" [value]="checkLAP">
                    {{checkLAP}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkLaps').errors?.required">
                  Select Check LAP's
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Cabinet Vendor {{asterisk}}" [(ngModel)]="lastVisitInfoForm.cabinetVendor"
                  formControlName="cabinetVendor">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let cabinetVendor of cabinetVendors" [value]="cabinetVendor">
                    {{cabinetVendor}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('cabinetVendor').errors?.required">
                  Select Cabinet Vendor
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Cabinet Battery Capacity {{asterisk}}" [(ngModel)]="lastVisitInfoForm.cabinetBattery"
                formControlName="cabinetBattery">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryCapacity of batteryCapacitievalues" [value]="batteryCapacity">
                    {{batteryCapacity}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('cabinetBattery').errors?.required">
                  Select Cabinet Battery Capacity
                </mat-error>
              </mat-form-field>

              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Check Operating Lights {{asterisk}}" [(ngModel)]="lastVisitInfoForm.checkOperating"
                formControlName="checkOperating">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let operatingLight of operatingLightvalues" [value]="operatingLight">
                    {{operatingLight}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('checkOperating').errors?.required">
                  Select Check Operating Lights
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Did you clean dust & dirt from enclosure ?</span><br><br>
                  <mat-radio-group *ngFor="let cleanDustOption of CleanDustDirtFromEnclosure" formControlName="cleanDust"
                    [(ngModel)]="lastVisitInfoForm.cleanDust">
                    <mat-radio-button class="mar-right" [value]="cleanDustOption">{{cleanDustOption}}</mat-radio-button>
                    <!-- <mat-radio-button value="Lectro">Lectro</mat-radio-button> -->
                  </mat-radio-group>

                </span>
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cleanDust'])" placeholder="" style="display: none;" formControlName="cleanDust">
                <mat-error *ngIf="lastVisitInfoForm.get('cleanDust').errors?.required">
                  Did you clean dust & dirt from enclosure is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Is the Cabinet Locked</span><br><br>
                  <mat-radio-group formControlName="cabinetLocked" [(ngModel)]="lastVisitInfoForm.cabinetLocked">
                    <mat-radio-button class="mar-right" *ngFor="let cabinetLockOption of cabinetLockOptionvalues"
                      [value]="cabinetLockOption">
                      {{cabinetLockOption}}</mat-radio-button>
                    <!-- <mat-radio-button value="No">No</mat-radio-button> -->
                  </mat-radio-group>
                </span>
                <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cabinetLocked'])" placeholder="" style="display: none;" formControlName="cabinetLocked">
                <mat-error *ngIf="lastVisitInfoForm.get('cabinetLocked').errors?.required">
                  Is the Cabinet Locked is required
                </mat-error>
              </mat-form-field>
            </p>

            <!-- <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Follow Up Action Needed {{asterisk}}" [(ngModel)]="lastVisitInfoForm.followUp"
                  formControlName="followUp">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let followUpActionOption of followUpActionvalue" [value]="followUpActionOption">
                    {{followUpActionOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('followUp').errors?.required">
                  Select Follow Up Action Needed
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Input Surge Arrestor {{asterisk}}" [(ngModel)]="lastVisitInfoForm.inputSurge"
                  formControlName="inputSurge">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let surgeArrestorInput of surgeArrestorInputs" [value]="surgeArrestorInput">
                    {{surgeArrestorInput}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('inputSurge').errors?.required">
                  Select Input Surge Arrestor
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Output Surge Arrestor {{asterisk}}" [(ngModel)]="lastVisitInfoForm.outputSurge"
                  formControlName="outputSurge">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let outputSurgeArrestor of outputSurgeArrestors" [value]="outputSurgeArrestor">
                    {{outputSurgeArrestor}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('outputSurge').errors?.required">
                  Select Output Surge Arrestor
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Coax TVSS Present {{asterisk}}" [(ngModel)]="lastVisitInfoForm.coaxTvss"
                  formControlName="coaxTvss">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let coaxOption of coaxOptionvalues" [value]="coaxOption">
                    {{coaxOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('coaxTvss').errors?.required">
                  Select Coax TVSS Present
                </mat-error>
              </mat-form-field>
            </p> -->
            <p>
              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="AC Indicator Green light (ACI) {{asterisk}}" [(ngModel)]="lastVisitInfoForm.acIndicator"
                formControlName="acIndicator">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let ACIOption of ACIOptionvalues" [value]="ACIOption">
                    {{ACIOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('acIndicator').errors?.required">
                  Select AC Indicator Green light
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Local and Remote Indicator (LRI) {{asterisk}}" [(ngModel)]="lastVisitInfoForm.lri"
                formControlName="lri">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let LRIOption of LRIOptionvalues" [value]="LRIOption">
                    {{LRIOption}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('lri').errors?.required">
                  Select Local and Remote Indicator (LRI)
                </mat-error>
              </mat-form-field> -->

              <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Did you check ground connection at cabinet?</span><br><br>
                  <mat-radio-group formControlName="checkGround" [(ngModel)]="lastVisitInfoForm.checkGround">
                    <mat-radio-button class="mar-right" *ngFor="let checkGroundConnection of checkGroundConnectionvalues"
                      [value]="checkGroundConnection">{{checkGroundConnection}}</mat-radio-button>
                    <!-- <mat-radio-button value="No">No</mat-radio-button> -->
                  </mat-radio-group>
                </span>
                <input matInput  (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['checkGround'])" placeholder="" style="display: none;" formControlName="checkGround">
                <mat-error *ngIf="lastVisitInfoForm.get('checkGround').errors?.required">
                  Check ground connection at cabinet is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <span class="infix" style="width: 50%;">
                  <span>Is a tamper installed and functioning?</span><br><br>
                  <mat-radio-group formControlName="tamperInstalled" [(ngModel)]="lastVisitInfoForm.tamperInstalled">
                    <mat-radio-button class="mar-right" *ngFor="let tamperInstalledOption of tamperInstalledvalue"
                      [value]="tamperInstalledOption">{{tamperInstalledOption}}</mat-radio-button>&nbsp;
                    <!-- <mat-radio-button value="No">No</mat-radio-button> -->
                  </mat-radio-group>
                </span>
                <input matInput  (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['tamperInstalled'])" placeholder="" style="display: none;" formControlName="tamperInstalled">
                <mat-error *ngIf="lastVisitInfoForm.get('tamperInstalled').errors?.required">
                  Is a tamper installed and functioning?
                </mat-error>
              </mat-form-field>
            </p>

            <p>
              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Input Surge Arrestor {{asterisk}}" [(ngModel)]="lastVisitInfoForm.inputSurge"
                  formControlName="inputSurge">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let surgeArrestorInput of surgeArrestorInputs" [value]="surgeArrestorInput">
                    {{surgeArrestorInput}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('inputSurge').errors?.required">
                  Select Input Surge Arrestor
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Output Surge Arrestor {{asterisk}}" [(ngModel)]="lastVisitInfoForm.outputSurge"
                  formControlName="outputSurge">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let outputSurgeArrestor of outputSurgeArrestors" [value]="outputSurgeArrestor">
                    {{outputSurgeArrestor}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('outputSurge').errors?.required">
                  Select Output Surge Arrestor
                </mat-error>
              </mat-form-field>
            </p>
          </div>
          <!-- <mat-form-field style="width:290px;">
            <mat-label>Last Visit Comments</mat-label>
            <textarea matInput rows="3" formControlName="lastVisitComments"></textarea>
            <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
            <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.required">
              Last Visit Comments
            </mat-error>
          </mat-form-field> -->
          <!-- <mat-form-field class="" style="width: 800px;">
            <mat-label>Last Visit Comments</mat-label>
            <textarea matInput rows="3" formControlName="lastVisitComments"></textarea>
            <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
          </mat-form-field> -->
        </div>
        <div class="infixcheck">
          <label class="mat-form-field-infix-class"><b style="margin-left:35px;color: #7e7e7e;
          font-size: 15px;">Did you check the following?</b></label>
          <div style="margin-left:35px;" class="didVerify">
          <label class="labelfollow">Seizure screw/alt box</label><br>
          <label class="labelfollow">Power co riser condition</label><br>
          <label class="labelfollow">20 amp hi-magnetic circuit breaker</label><br>
          <label class="labelfollow">LAP's</label><br>
          <label class="labelfollow">Cabinet Condition</label><br>
          <label class="labelfollow">Inspect wire harnesses/connectors</label><br>
          <label class="labelfollow">Lamps/LEDS</label><br>
          <label class="labelfollow">Battery temperature probes</label><br>
          <label class="labelfollow">XOC Verified transponder is operational</label><br>
          <label class="labelfollow">Operating/AC indicator lights</label><br>
          <label class="labelfollow">Service entrance</label><br>
          <label class="labelfollow">Power Supply Id is legible</label><br>
          <label class="labelfollow">Local remote Indicator</label><br>
            <p><label class="example-margin labelfollow">Verified All</label>&nbsp;&nbsp;
              <mat-checkbox [checked]="isCheckedCheck" #chkEnable (change)="SelectAllOk(chkEnable.checked)"></mat-checkbox>
              <mat-error style="font-size: 12px;" *ngIf="lastVisitInfoForm.get('checkAll').errors?.required">
                Please verify all
              </mat-error>
            </p>
          </div>
        </div>
      </form>
    </mat-tab>
    <mat-tab *ngIf="lastCert && showApu">
      <ng-template mat-tab-label>
        <span>Add APU Visit</span> &nbsp;
        <div *ngIf="apuVisitFormGroup.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <div align="center">
        <form id="apuVisitFormGroup" [formGroup]="apuVisitFormGroup">
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuinspectionDate'])" [matDatepicker]="pickerapuvisit" placeholder="Inspection Date"
              formControlName="apuinspectionDate">
            <mat-datepicker-toggle matSuffix [for]="pickerapuvisit"></mat-datepicker-toggle>
            <mat-datepicker #pickerapuvisit></mat-datepicker>
            <mat-error *ngIf="apuVisitFormGroup.get('apuinspectionDate').errors?.required">
              Inspection Date is required
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuVisitedTech'])" placeholder="APU Visit completed by Tech" formControlName="apuVisitedTech">
            <mat-error *ngIf="apuVisitFormGroup.get('apuVisitedTech').errors?.required">
              APU Visit completed by Tech is required
            </mat-error>
          </mat-form-field>
          <div class="d-flex flex-wrap justify-content-evenly">
            <div class="">
              <span class="formTitle">APU Starter Battery</span>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="APU Battery Manufacturer/Type" formControlName="apuBatteryManuType">
                  <mat-option *ngFor="let apuBatteryManuType of batteryManufactureres" [value]="apuBatteryManuType">
                    {{apuBatteryManuType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryManuType').errors?.required">
                  Select APU Battery Manufacturer/Type
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryDateCode'])" placeholder="APU Battery Date Code" formControlName="apuBatteryDateCode">
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryDateCode').errors?.required">
                  APU Battery Date Code is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryInstallDate'])" [matDatepicker]="picker1" placeholder="APU Battery Install Date"
                  formControlName="apuBatteryInstallDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryInstallDate').errors?.required">
                  APU Battery Install Date is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryVltgNoLoad'])" placeholder="APU Battery Voltage - No Load" (keypress)="numberOnly($event)" formControlName="apuBatteryVltgNoLoad">
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryVltgNoLoad').errors?.validateNumber">
                  APU Battery Voltage - No Load <strong>Should</strong> only include numbers !!
                </mat-error>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryVltgNoLoad').errors?.required">
                  APU Battery Voltage - No Load is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryConductance'])"  placeholder="APU Battery Conductance (mhos)" (keypress)="numberOnly($event)" formControlName="apuBatteryConductance">
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryConductance').errors?.validateNumber">
                  APU Battery Conductance <strong>Should</strong> only include numbers !!
                </mat-error>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryConductance').errors?.required">
                  APU Battery Conductance (mhos) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryCon77deg'])" placeholder="APU Battery Conductance - Corrected to 77deg F"
                  formControlName="apuBatteryCon77deg">
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryCon77deg').errors?.required">
                  APU Battery Conductance - Corrected to 77deg F is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuBatteryTorque'])" placeholder="APU Battery Torque in LBS" (keypress)="numberOnly($event)" formControlName="apuBatteryTorque">
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryTorque').errors?.validateNumber">
                  APU Battery Torque <strong>Should</strong> only include numbers !!
                </mat-error>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryTorque').errors?.required">
                  APU Battery Torque in LBS is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="APU Battery Terminals cleaned" formControlName="apuBatteryTerminals">
                  <mat-option *ngFor="let apuBatteryTerminal of apuBatteryTerminals" [value]="apuBatteryTerminal">
                    {{apuBatteryTerminal}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryTerminals').errors?.required">
                  Select APU Battery Terminals cleaned
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuStarter'])"  placeholder="APU Starter battery charger Voltage" (keypress)="numberOnly($event)" formControlName="apuStarter">
                <mat-error *ngIf="apuVisitFormGroup.get('apuStarter').errors?.validateNumber">
                  APU Starter battery charger Voltage <strong>Should</strong> only include numbers !!
                </mat-error>
                <mat-error *ngIf="apuVisitFormGroup.get('apuStarter').errors?.required">
                  APU Starter battery charger Voltage is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuCharger'])" placeholder="APU Charger current (amps)" (keypress)="numberOnly($event)" formControlName="apuCharger">
                <mat-error *ngIf="apuVisitFormGroup.get('apuCharger').errors?.validateNumber">
                  APU Charger current <strong>Should</strong> only include numbers !!
                </mat-error>
                <mat-error *ngIf="apuVisitFormGroup.get('apuCharger').errors?.required">
                  APU Charger current (amps) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Follow Up Action Needed" formControlName="followup">
                  <mat-option *ngFor="let followup of followups" [value]="followup">
                    {{followup}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('followup').errors?.required">
                  Select Follow Up Action Needed is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['recordAsFoundAlarms'])"  placeholder="Record as found alarms" formControlName="recordAsFoundAlarms">
                <mat-error *ngIf="apuVisitFormGroup.get('recordAsFoundAlarms').errors?.required">
                  Record as found alarms
                </mat-error>
              </mat-form-field>
            </div>
            <div class="">
              <span class="formTitle">APU</span>
              <br>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="APU test run (10 min under load)" formControlName="apuTestRun">
                  <mat-option *ngFor="let apuTestRun of apuTestRuns" [value]="apuTestRun">
                    {{apuTestRun}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('apuTestRun').errors?.required">
                  Select APU test run (10 min under load) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Check Oil Level" formControlName="checkOilLevel">
                  <mat-option *ngFor="let checkOilLevel of checkOilLevels" [value]="checkOilLevel">
                    {{checkOilLevel}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('checkOilLevel').errors?.required">
                  Select Check Oil Level
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['ifOilAdded'])" placeholder="If Oil Added; Amount" formControlName="ifOilAdded">
                <mat-error *ngIf="apuVisitFormGroup.get('ifOilAdded').errors?.required">
                  If Oil Added is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Oil Filter Tight" formControlName="oilFilterTight">
                  <mat-option *ngFor="let oilFilterTight of oilFilterTights" [value]="oilFilterTight">
                    {{oilFilterTight}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('oilFilterTight').errors?.required">
                  Select Oil Filter Tight
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Inspect Generator Air Filter" formControlName="inspectGenerator">
                  <mat-option *ngFor="let inspectGenerator of inspectGenerators" [value]="inspectGenerator">
                    {{inspectGenerator}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('inspectGenerator').errors?.required">
                  Select Inspect Generator Air Filter
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Inspect Spark Plug" formControlName="inspectSparkPlug">
                  <mat-option *ngFor="let inspectSparkPlug of inspectSparkPlugs" [value]="inspectSparkPlug">
                    {{inspectSparkPlug}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('inspectSparkPlug').errors?.required">
                  Select Inspect Spark Plug
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Clear APU event log" formControlName="clearApuEventlog">
                  <mat-option *ngFor="let clearApuEventlog of clearApuEventlogs" [value]="clearApuEventlog">
                    {{clearApuEventlog}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('clearApuEventlog').errors?.required">
                  Select Clear APU event log
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['apuFrequency'])" placeholder="APU Frequency (hz)" formControlName="apuFrequency">
                <mat-error *ngIf="apuVisitFormGroup.get('apuFrequency').errors?.required">
                  APU Frequency (hz) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['tank1'])" placeholder="Tank # 1 (Level - If LP)" formControlName="tank1">
                <mat-error *ngIf="apuVisitFormGroup.get('tank1').errors?.required">
                  Tank1 is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['tank2'])" placeholder="Tank # 2 (Level - If LP)" formControlName="tank2">
                <mat-error *ngIf="apuVisitFormGroup.get('tank2').errors?.required">
                  Tank2 is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['gasMeter'])" placeholder="Gas Meter # (If NG gas)" formControlName="gasMeter">
                <mat-error *ngIf="apuVisitFormGroup.get('gasMeter').errors?.required">
                  Gas Meter # (If NG gas) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['gasMeterReading'])"  placeholder="Gas Meter reading (If NG gas)" formControlName="gasMeterReading">
                <mat-error *ngIf="apuVisitFormGroup.get('gasMeterReading').errors?.required">
                  Gas Meter reading (If NG gas) is required
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <input matInput (change)="trimLeadingAndTrailingSpaces(apuVisitFormGroup.controls['ngPressure'])" placeholder="NG Pressure" formControlName="ngPressure">
                <mat-error *ngIf="apuVisitFormGroup.get('ngPressure').errors?.required">
                  NG Pressure is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="">
              <span class="formTitle" style="text-align: center !important;">Enclosure/PAD</span>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Change/clean enclosure air filter" formControlName="airFilter">
                  <mat-option *ngFor="let airFilter of airFilters" [value]="airFilter">
                    {{airFilter}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('airFilter').errors?.required">
                  Select Change/clean enclosure air filter
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Check for rodent/insect damage" formControlName="rodentInsectDamage">
                  <mat-option *ngFor="let rodentInsectDamage of rodentInsectDamages" [value]="rodentInsectDamage">
                    {{rodentInsectDamage}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('rodentInsectDamage').errors?.required">
                  Select Check for rodent/insect damage
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Check Lamps & LED" formControlName="checkLamps">
                  <mat-option *ngFor="let checkLamp of checkLamps" [value]="checkLamp">
                    {{checkLamp}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('checkLamps').errors?.required">
                  Select Check Lamps & LED
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Clear weeds back 36 Inches if ground mount unit" formControlName="clearWeeds">
                  <mat-option *ngFor="let clearWeed of clearWeeds" [value]="clearWeed">
                    {{clearWeed}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('clearWeeds').errors?.required">
                  Select Clear weeds back 36 Inches if ground mount unit
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Check & re-grout pad conduit openings as needed"
                  formControlName="checkRegrout">
                  <mat-option *ngFor="let checkRegrout of checkRegrouts" [value]="checkRegrout">
                    {{checkRegrout}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('checkRegrout').errors?.required">
                  Select Check & re-grout pad conduit openings as needed
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="If Ground Mount Any pad undermining" formControlName="ifGroundMount">
                  <mat-option *ngFor="let ifGroundMount of ifGroundMounts" [value]="ifGroundMount">
                    {{ifGroundMount}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('ifGroundMount').errors?.required">
                  Select If Ground Mount Any pad undermining
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Any enclosure damage or Vandalism" formControlName="anyEnclosure">
                  <mat-option *ngFor="let anyEnclosure of anyEnclosures" [value]="anyEnclosure">
                    {{anyEnclosure}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('anyEnclosure').errors?.required">
                  Select Any enclosure damage or Vandalism
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Clean up garbage with in immediate vicinity" formControlName="cleanUpGarbage">
                  <mat-option *ngFor="let cleanUpGarbage of cleanUpGarbages" [value]="cleanUpGarbage">
                    {{cleanUpGarbage}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('cleanUpGarbage').errors?.required">
                  Select Clean up garbage with in immediate vicinity
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Test Oil pressure alarm" formControlName="testOilPressure">
                  <mat-option *ngFor="let testOilPressure of testOilPressures" [value]="testOilPressure">
                    {{testOilPressure}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testOilPressure').errors?.required">
                  Select Test Oil pressure alarm
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Test High Temperature Alarm" formControlName="testhighTemp">
                  <mat-option *ngFor="let testhighTemp of testhighTemps" [value]="testhighTemp">
                    {{testhighTemp}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testhighTemp').errors?.required">
                  Select Test High Temperature Alarm
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Generator DC Bus function" formControlName="generatorDcBus">
                  <mat-option *ngFor="let generatorDcBus of generatorDcBuses" [value]="generatorDcBus">
                    {{generatorDcBus}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('generatorDcBus').errors?.required">
                  Select Generator DC Bus function
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Check for gas leaks" formControlName="checkForGas">
                  <mat-option *ngFor="let checkForGas of checkForGases" [value]="checkForGas">
                    {{checkForGas}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('checkForGas').errors?.required">
                  Select Check for gas leaks
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Test Combustible Gas Alarm" formControlName="testCombustible">
                  <mat-option *ngFor="let testCombustible of testCombustibles" [value]="testCombustible">
                    {{testCombustible}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testCombustible').errors?.required">
                  Select Test Combustible Gas Alarm
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="Test Tamper alarm" formControlName="testTamper">
                  <mat-option *ngFor="let testTamper of testTampers" [value]="testTamper">
                    {{testTamper}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testTamper').errors?.required">
                  Select Test Tamper alarm
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="If ground mount Test Water Intrusion Alarm"
                  formControlName="testWaterIntrusion">
                  <mat-option *ngFor="let testWaterIntrusion of testWaterIntrusions" [value]="testWaterIntrusion">
                    {{testWaterIntrusion}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testWaterIntrusion').errors?.required">
                  Select If ground mount Test Water Intrusion Alarm
                </mat-error>
              </mat-form-field>
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select placeholder="If ground mount Test Pad Shear Alarm" formControlName="testPad">
                  <mat-option *ngFor="let testPad of testPads" [value]="testPad">
                    {{testPad}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="apuVisitFormGroup.get('testPad').errors?.required">
                  Select If ground mount Test Pad Shear Alarm
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <mat-form-field style="width: 800px;">
            <mat-label>APU Visit Comments</mat-label>
            <textarea matInput rows="3" formControlName="comments"></textarea>
            <mat-error *ngIf="apuVisitFormGroup.get('comments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
          </mat-form-field>
        </form>
      </div>
    </mat-tab>
<!--Show Alerts/Events-->
      <!-- <mat-expansion-panel> -->
        <!-- <mat-expansion-panel-header class="accord_cls">
          <mat-panel-title>
            <h5><b class="fontpsaccord">Show Alerts/Events</b></h5>
          </mat-panel-title>
        </mat-expansion-panel-header> -->
        <mat-tab *ngIf="showAlertsEnable==1?false:true">
          <ng-template mat-tab-label>
            <span>Show Alerts/Events</span> &nbsp;
          </ng-template>
        <div class="clr"></div>
        <mat-toolbar color="primary">
          <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Alerts/Events Info</b></div>
        </mat-toolbar>

        <div class="w3-row-padding fontpsaccord">
          <!-- <h1 mat-dialog-title class="text-center colorFill" style="margin:0px;">Transponder Operations History</h1> -->
          <mat-form-field class="px-16" style="width: 50%">
              <input matInput  [(ngModel)]="searchText" placeholder="Search..." autocomplete="off" style="width: 100%">
              <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
          <div *ngIf="noData" class="noResult">No Records to Show</div>
          <div *ngIf="!noData" class="wrapper">
            <!-- {{alertResult['psAlertsList'] | json}} -->
              <div *ngFor="let activealerts of alertResultData | filter: searchText; let i = index">
              <p mat-list-item><b>Power Supply Name:
              </b>{{activealerts.powerSupplyName != null ? activealerts.powerSupplyName : '-' }}
              </p>
              <p mat-list-item><b>IP Address:
                  </b>{{activealerts.ip != null ? activealerts.ip : '-' }}
              </p>
              <p mat-list-item><b>Mac Address:
                  </b>{{activealerts.macAddress != null ? activealerts.macAddress : '-' }}
              </p>
              <p mat-list-item><b>Alert Start Time:
                  </b>{{activealerts.alertStartTime != null ? activealerts.alertStartTime : '-' }}
              </p>
              <p mat-list-item><b>Alert Duration:
                  </b>{{activealerts.alertDuration != null ? activealerts.alertDuration : '-' }}
              </p>
              <p mat-list-item><b>Alert Type:
                  </b>{{activealerts.alertDesc != null ? activealerts.alertDesc : '-' }}
              </p>
              <p mat-list-item><b>Alert Description:
                  </b>{{activealerts.alertDetails != null ? activealerts.alertDetails : '-' }}
              </p>
              <p mat-list-item><b>Alert Level:
                  </b>{{activealerts.alertLevel != null ? activealerts.alertLevel : '-' }}
              </p>
              <p mat-list-item *ngIf="activealerts.totalCustomersOffline && activealerts.totalCustomers"><b>Customers
                      Offline: </b>{{activealerts.totalCustomersOffline + '/' + activealerts.totalCustomers}}
              </p>
              <p mat-list-item><b>Impacted Devices:
                  </b>{{activealerts.impactedDevices != null ? activealerts.impactedDevices : '-' }}
              </p>
              <p mat-list-item><b>PS State: </b>{{activealerts.psState == null ? '-' : (activealerts.psState == 'on_battery' ? 'on_standby' : activealerts.psState) }}</p>
              <p mat-list-item *ngIf="activealerts.psExpectedFailureTime"><b>Expected Failure Time: </b>{{ activealerts.psExpectedFailureTime }}</p>
              <p mat-list-item *ngIf="activealerts.batteryTimeMinsRemaining"><b>Battery Runtime Remaining: </b>{{ activealerts.batteryTimeMinsRemaining }} Mins</p>
              <p mat-list-item><b>Network Impact:
                  </b>{{activealerts.networkImpact != null ? activealerts.networkImpact : '-' }}
              </p>
              <p mat-list-item><b>CMTS: </b>{{activealerts.cmts != null ? activealerts.cmts : '-' }}</p>
              <p mat-list-item><b>Primary Node: </b>{{activealerts.ncpnode != null ? activealerts.ncpnode : '-' }}</p>
              <!-- <p mat-list-item><b>Hierarchy Path: </b>{{activealerts.hierarchyPathLabels != null ? activealerts.hierarchyPathLabels : '-' }}</p> -->
              <p mat-list-item><b>Current Score:
                  </b>{{activealerts.psScoreCurrent != null ? activealerts.psScoreCurrent : '-' }}
              </p>
              <p mat-list-item><b>Alert Score:
                  </b>{{activealerts.psScoreAlert != null ? activealerts.psScoreAlert : '-' }}
              </p>
                  <div class="block_line" color="accent"></div>
              </div>
          </div>
        </div>
        </mat-tab>
        <!-- expension start -->

        <!-- expension end -->
   <!--Edit PS Cert-->
    <mat-tab *ngIf="showLastCertEnable==1?false:true" label="Last Certification">
      <ng-template matTabContent>
        <mat-tab-group [(selectedIndex)]="subselectedTabIndex">
          <mat-tab label="History">
            <app-psnb-certhistory [powerSupplyIdval]="powerSupplyIdval" [certId]="certId"></app-psnb-certhistory>
            <!--<psnb-certification [powerSupplyIdval]="powerSupplyIdval" [certId]="certId"></psnb-certification>-->
          </mat-tab>
          <mat-tab *ngIf="DetailView" label="Latest Certification">
          <!-- Heelostart -->
          <div style="padding-bottom: 50px;">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Location Info</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Location Info</b></div>
                </mat-toolbar> -->
                <br>
                <div class="w3-row-padding fontpsaccord">
                  <div class="w3-third font_class">
                    <p><b>House Number:</b>{{certData['powerSupplyCertifications']['houseNumber']}}</p>
                    <p><b>Street:</b>{{certData['powerSupplyCertifications'].powerSupplyAddress}}</p>
                    <p><b>Cross Street:</b>{{certData['powerSupplyCertifications'].crossStreet}}</p>
                    <p><b>City:</b> {{certData['powerSupplyCertifications'].city}}</p>
                    <p><b>State:</b>{{certData['powerSupplyCertifications'].state}}</p>
                  </div>
                <div class="w3-third font_class">
                    <p><b>Zip:</b> {{certData['powerSupplyCertifications'].zip}}</p>
                    <p><b>GPS Latitude:</b> {{(gpsgreaterFlag) ? certData['powerSupplyCertifications'].gpsLatitude :  certData['powerSupplyCertifications'].gpsLatitude | number:'.6' }}</p>
                    <p><b>GPS Longitude:</b>{{(gpsgreaterFlag) ? certData['powerSupplyCertifications'].gpsLongitude : certData['powerSupplyCertifications'].gpsLongitude | number:'.6' }}</p>
                    <p><b>Powers Node:</b>{{certData['powerSupplyCertifications'].powersNode}}</p>
                    <p><b>Pole#:</b>{{certData['powerSupplyCertifications'].poleNumber}}</p>
                </div>
                <div class="w3-third font_class">
                    <p><b>Underground/Aerial:</b>{{certData['powerSupplyCertifications'].aerialUnderground}}</p>
                    <p><b>Calculated Runtime(in Minutes):</b> {{certData['powerSupplyCertifications'].calculatedRuntime}}</p>
                    <p><b>Special Location Details:</b>{{certData['powerSupplyCertifications'].gpsLatitude}}</p>
                    <p><b>Power Company:</b>{{certData['powerSupplyCertifications'].utilityProvider}}</p>
                    <p><b>Power Company Account Number:</b>{{certData['powerSupplyCertifications'].companyAccountNumber}}</p>
                </div>
                <div class="w3-third font_class">
                  <p><b>Power Company Contact Number:</b>{{certData['powerSupplyCertifications'].powerCompanyContactNumber}}</p>
                  <p><b>Power Company Website:</b> <a href="{{certData['powerSupplyCertifications'].powerCompanyWebsite}}" target="_blank">{{certData['powerSupplyCertifications'].powerCompanyWebsite}}</a></p>
                  <p><b>NWT Team:</b>{{certData['powerSupplyCertifications'].nwtTeam}}</p>
                  <p><b>Nitro Completion Date:</b> {{certData['powerSupplyCertifications'].nitroCompletionDate}}</p>
                </div>
                  <div class="w3-third font_class">
                    <p><b>Power Company Account Type:</b>{{certData['powerSupplyCertifications'].powerAccountType}}</p>
                    <p><b>Map Page Number:</b>{{certData['powerSupplyCertifications'].mapNumber}}</p>
                    <p><b>Business Partner Restriction::</b>{{certData['powerSupplyCertifications'].businessPartnerRestriction}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>Location Comments:</b>{{certData['powerSupplyCertifications'].locationComments}}</p>
                  </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Transponder Info</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Transponder Info</b></div>
                </mat-toolbar> -->
                <br>
                <div class="w3-row-padding fontpsaccord">
                  <div class="w3-third font_class">
                    <p><b>Power Supply Name:</b>{{certData['powerSupplyCertifications'].powerSupplyName}}</p>
                    <p><b>Mac address:</b>{{certData['powerSupplyCertifications'].macAddress}}</p>
                    <p><b>Previous Mac Address:</b>{{certData['powerSupplyCertifications'].macAddressPrevious}}</p>
                    <p><b>IP:</b> {{certData['powerSupplyCertifications'].ip}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>PS Type:</b> {{certData['powerSupplyCertifications'].powerSupplyType}}</p>
                    <p><b>PS Number:</b> {{certData['powerSupplyCertifications'].powerSupplyNumber}}</p>
                    <p><b>PS Model:</b>{{certData['powerSupplyCertifications'].powerSupplyModel}}</p>
                    <p><b>AC Input voltage:</b>{{certData['powerSupplyCertifications'].acInputVoltage}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>AC Output voltage:</b>{{certData['powerSupplyCertifications'].outputVoltage}}</p>
                    <p><b>Current Amp rating:</b> {{certData['powerSupplyCertifications'].inputCurrent}}</p>
                    <!-- <p><b>Current Amp (Output rating):</b>{{certData['powerSupplyCertifications'].currentAmpOutput}}</p> -->
                    <p><b>AlertProfile:</b>{{certData['powerSupplyCertifications'].alertProfile}}</p>
                    <p><b>Ethernet Connected Device:</b>{{certData['powerSupplyCertifications'].externalSensor}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>SerialNumber:</b>{{certData['powerSupplyCertifications'].serialNumber}}</p>
                    <p><b>DC Ready:</b> {{certData['powerSupplyCertifications'].dcReady}}</p>
                    <!-- <p><b>Controller Card Type:</b>{{certData['powerSupplyCertifications'].controllerCardType}}</p> -->
                    <p><b>Priority:</b>{{certData['powerSupplyCertifications'].priority}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>EGIS Number:</b>{{certData['powerSupplyCertifications'].egisName}}</p>
                    <p><b>Global Identifier:</b>{{certData['powerSupplyCertifications'].globalId}}<p>
                    <p><b>Transponder Vendor:</b>{{certData['powerSupplyCertifications'].transponderVendor}}</p>
                    <p><b>Transponder Model:</b>{{certData['powerSupplyCertifications'].transponderModel}}</p>
                  </div>
                  <div class="w3-third font_class">
                    <p><b>Transponder comments:</b>{{certData['powerSupplyCertifications'].transponderComments}}</p>
                  </div>
                </div>
              </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header class="accord_cls">
                <mat-panel-title>
                  <h5 class="font-size-text"><b class="fontpsaccord">Battery Info</b></h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="clr"></div>
              <!-- <mat-toolbar color="primary">
                <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Battery Info</b></div>
              </mat-toolbar> -->
              <div class="w3-row-padding fontpsaccord">
                <br>
                <div class="w3-third font_class">
                  <p><b>Number of Batteries:</b>{{certData['powerSupplyCertifications'].numberOfBatteries}}</p>
                </div>
                <div class="w3-third font_class">
                  <p><b>Batteries Replaced?:</b>{{certData['powerSupplyCertifications'].batteriesReplaced}}</p>
                </div>
                <div class="w3-third font_class">
                  <!-- <p><b>Battery Manager</b>{{certData['powerSupplyCertifications'].hasBatteryBalancer}}</p> -->
                  <!-- <p><b>Battery Manager:</b> {{powerSupply.batteryComments}}</p> -->
                  <p><b>Battery Balancer String :</b> {{certData['powerSupplyCertifications'].batteryBalancerString}}</p>
                </div>
                <div class="w3-third font_class">
                <p><b>Comments:</b>{{certData['powerSupplyCertifications'].batteryComments}}</p>
              </div>
                <br>

                <div *ngIf='parallelBatt && !lionBatt'>
                <div *ngFor="let string of noOfStrings;">
                  <!-- <p><b>Battery Manager Model (String {{string}}): {{batteryManagerModels1[string-1]}}</b></p> -->
                  <div *ngFor="let battery of noOfBatteries1;" class="w3-third font_class">
                    <p class="bat_clr"> String {{string}} - Parallel  Battery {{battery}}</p>
                    <p><b>Battery Manufacturer/Type:</b> {{batteryManufacturers.get(string + ',' + battery)}}</p>
                    <p><b>Battery Serial Number:</b>{{batterySerial.get(string + ',' + battery)}}</p>
                    <p><b>Battery Date Code (On Battery):</b> {{batteryDateCodes.get(string + ',' + battery)}}</p>
                    <p><b>Battery Install Date:</b> {{batteryInstallDates.get(string + ',' +
                    battery)}}</p>
                    <p><b>Battery Voltage - No Load:</b> {{batteryVoltages.get(string + ',' + battery)}}</p>
                  </div>
                </div>
              </div>
              <div *ngIf='!parallelBatt && !lionBatt'>
                <div *ngFor="let string of noOfStrings;">
                  <!-- <p><b>Battery Manager Model (String {{string}}): {{batteryManagerModels1[string-1]}}</b></p> -->
                  <div *ngFor="let battery of noOfBatteries1;" class="w3-third font_class">
                    <p class="bat_clr"> String {{string}} - Battery {{battery}}</p>
                    <p><b>Battery Manufacturer/Type:</b> {{batteryManufacturers.get(string + ',' + battery)}}</p>
                    <p><b>Battery Serial Number:</b> {{batterySerial.get(string + ',' + battery)}}</p>
                    <p><b>Battery Date Code (On Battery):</b> {{batteryDateCodes.get(string + ',' + battery)}}</p>
                    <p><b>Battery Install Date:</b> {{batteryInstallDates.get(string + ',' +
                    battery)}}</p>
                    <p><b>Battery Voltage - No Load:</b> {{batteryVoltages.get(string + ',' + battery)}}</p>

                  </div>
                </div>
              </div>

              <div *ngIf='!parallelBatt && lionBatt'>
                <!-- <p><b>Battery Manager Model (String 1): {{batteryManagerModels1[1]}}</b></p> -->
                <p class="bat_clr"> String 1 - Battery 1</p>
                <p><b>Battery Manufacturer/Type:</b> {{certData['powerSupplyCertifications'].type11}}</p>
                <p><b>Battery Serial Number:</b> {{certData['powerSupplyCertifications'].batterySerial11}}</p>
                <p><b>Battery Date Code (On Battery):</b> {{certData['powerSupplyCertifications'].manufactureDate11}}</p>
                <p><b>Battery Install Date:</b> {{certData['powerSupplyCertifications'].installDate11}}</p>
                <p><b>Battery Voltage - No Load:</b> {{certData['powerSupplyCertifications'].voltage11}}</p>
              </div>

              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">APU</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>APU Info</b></div>
                </mat-toolbar> -->
                <br>
                <div class="w3-row-padding fontpsaccord">
                  <div class="w3-third font_class">
                    <p><b>APU - Make Model:</b>{{certData['apuCertifications'].apuMakeModel}}</p>
                    <p><b>APU Serial number:</b> {{certData['apuCertifications'].apuSerialNumber}}</p>
                    <p><b>APU Device Id:</b>{{certData['apuCertifications'].apuDeviceId}}</p>
                    <p><b>APU Runtime:</b> {{certData['apuCertifications'].apuRunTime}}</p>
                    <p><b>ECM/ACM:</b> {{certData['apuCertifications'].ecmAcm}}</p>
                    <p><b>APU Install Date:</b>{{apu_installed_date | date :'MM/dd/yyyy'}}</p>
                    <p><b>APU Output Voltage Rating:</b>{{certData['apuCertifications'].apuOutputVoltageRating}}</p>
                    <p><b>APU No Load Voltage:</b>{{certData['apuCertifications'].apuNoLoadVoltage}}</p>
                    <div class="w3-third font_class">
                    <p><b>APU Load Voltage:</b>{{certData['apuCertifications'].apuLoadVoltage}}</p>
                    <p><b>APU Enclosure Make/model:</b>{{certData['apuCertifications'].apuEnclosureMake}}</p>
                    <p><b>NG/LP:</b> {{certData['apuCertifications'].ngLp}}</p>
                    <p><b>NG Provider:</b> {{certData['apuCertifications'].ngProvider}}</p>
                    <p><b>LP Tank Capacity:</b>{{certData['apuCertifications'].lpTankCapacity}}</p>
                    <p><b>Number of Tanks Installed:</b>{{certData['apuCertifications'].numberTanksInstalled}}</p>
                    </div>
                  </div>
                  <mat-toolbar color="primary">
                    <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>APU Inspection</b></div>
                  </mat-toolbar>
                  <div class="w3-third font_class">
                    <p><b>Inspection date:</b>
                      {{apu_inspection_date | date :'MM/dd/yyyy'}}</p>
                      <p><b>Tech Info:</b>
                      {{certData['powerSupplyCertifications'].technicianNtUserName}}</p>
                  </div>
                  <mat-toolbar color="primary">
                    <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>APU Inspection - Battery</b></div>
                  </mat-toolbar>
                  <div class="w3-third font_class">
                      <p><b>APU Battery Manufacturer type:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryManufacturerType}}</p>
                      <p><b>APU Battery Date Code:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryDateCode}}</p>
                      <p><b>APU Battery install date:</b>
                      {{apu_battery_install_date | date :'MM/dd/yyyy'}}</p>
                      <p><b>APU Battery voltage - No Load:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryVoltageNoLoad}}</p>
                      <p><b>APU Battery Conductance - mhos:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryConductance}}</p>
                      <p><b>APU Battery Conductance - Corrected o 77 deg. F:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryConductanceCrrctd}}</p>
                      <p><b>APU Battery Torque in LBS:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryTorque}}</p>
                      <p><b>APU Battery terminals cleaned?:</b>
                      {{certData['apuShowVisitCertifications'].apuBatteryTerminalsCleaned}}</p>
                      <div class="w3-third font_class">
                      <p><b>APU Starter battery charger voltage:</b>
                      {{certData['apuShowVisitCertifications'].apuStarterBatteryChrgrVlt}}</p>
                      <p><b>APU Charge current (amps):</b>
                      {{certData['apuShowVisitCertifications'].apuChargerCurrentAmps}}</p>
                      <p><b>Followup action needed?:</b>
                      {{certData['apuShowVisitCertifications'].followUpActionNeeded}}</p>
                      <p><b>Record as found alarms:</b>
                      {{certData['apuShowVisitCertifications'].recordAsFoundAlarms}}</p>
                      </div>
                    </div>
                  <mat-toolbar color="primary">
                    <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>APU Info</b></div>
                  </mat-toolbar>
                  <div class="w3-third font_class">
                      <p><b>APU test run (10min under load):</b>
                      {{certData['apuShowVisitCertifications'].apuTestRun}}</p>
                      <p><b>Check Oil Level:</b>
                      {{certData['apuShowVisitCertifications'].checkOilLevel}}</p>
                      <p><b>If Oil added, amount:</b>
                      {{certData['apuShowVisitCertifications'].oilAddedAmount}}</p>
                      <p><b>Oil filter tight:</b>
                      {{certData['apuShowVisitCertifications'].oilFilterTight}}</p>
                      <p><b>Inspect Generator Air Filter:</b>
                      {{certData['apuShowVisitCertifications'].inspectGeneratorAirFilter}}</p>
                      <p><b>Inspect Spark Plug:</b>
                      {{certData['apuShowVisitCertifications'].inspectSparkPlug}}</p>
                      <p><b>Clear APU Event Log:</b>
                      {{certData['apuShowVisitCertifications'].clearApuEventLog}}</p>
                      <p><b>APU Frequency (HZ):</b>
                      {{certData['apuShowVisitCertifications'].apuFrequency}}</p>
                      <div class="w3-third font_class">
                      <p><b>Tank #1 (Level - if LP):</b>
                      {{certData['apuShowVisitCertifications'].tankOneLevel}}</p>
                      <p><b>Tank #2 (Level - if LP):</b>
                      {{certData['apuShowVisitCertifications'].tankTwoLevel}}</p>
                      <p><b>Gas Meter # (if NG Gas):</b>
                      {{certData['apuShowVisitCertifications'].gasMeterNumber}}</p>
                      <p><b>Gas Meter Reading (if NG Gas):</b>
                      {{certData['apuShowVisitCertifications'].gasMeterReading}}</p>
                      <p><b>NG Pressure :</b>
                      {{certData['apuShowVisitCertifications'].ngPressure}}</p>
                      </div>

                  </div>
                  <mat-toolbar color="primary">
                    <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>APU Inspection - Enclosure/PAD</b></div>
                  </mat-toolbar>
                  <div class="w3-third font_class">

                      <p><b>Change/Clean enclosure air filter:</b>
                      {{certData['apuShowVisitCertifications'].changeCleanenClosureAirFilter}}</p>
                      <p><b>Check for Rodent Damage:</b>
                      {{certData['apuShowVisitCertifications'].checkForRodentDamage}}</p>
                      <p><b>Check Lamps & LED:</b>
                      {{certData['apuShowVisitCertifications'].checkLampsLed}}</p>
                      <p><b>Clear weeds back 36 Inches if ground mount unit:</b>
                      {{certData['apuShowVisitCertifications'].clearWeeds}}</p>
                      <p><b>Check & re-grout pad conduit openings as needed:</b>
                      {{certData['apuShowVisitCertifications'].checkRegroutPadConduit}}</p>
                      <div class="w3-third font_class">
                        <p><b>If Ground Mount Any pad undermining:</b>
                          {{certData['apuShowVisitCertifications'].groundMountPadUndermining}}</p>
                        <p><b>Any enclosure damage or Vandalism:</b>
                          {{certData['apuShowVisitCertifications'].enclosureDamageVandalism}}</p>
                        <p><b>Clean up garbage with in immediate vicinity:</b>
                          {{certData['apuShowVisitCertifications'].cleanupGarbage}}</p>
                        <p><b>Test Oil pressure alarm:</b>
                          {{certData['apuShowVisitCertifications'].testOilPressureAlarm}}</p>
                        <p><b>Test High Temperature Alarm:</b>
                          {{certData['apuShowVisitCertifications'].testHighTempAlarm}}</p>
                      </div>
                      <p><b>Generator DC Bus function:</b>
                      {{certData['apuShowVisitCertifications'].generatorDcBusFunction}}</p>
                      <p><b>Check for gas leaks:</b>
                      {{certData['apuShowVisitCertifications'].checkForGasLeaks}}</p>
                      <p><b>Test Combustible Gas Alarm:</b>
                      {{certData['apuShowVisitCertifications'].testCombustibleGasAlarm}}</p>
                      <p><b>Test Tamper alarm:</b>
                      {{certData['apuShowVisitCertifications'].testTamperAlarm}}</p>
                      <p><b>If ground mount Test Water Intrusion Alarm:</b>
                      {{certData['apuShowVisitCertifications'].testWaterIntrusionAlarm}}</p>
                      <p><b>If ground mount Test Pad Shear Alarm:</b>
                      {{certData['apuShowVisitCertifications'].testPadShearAlarm}}</p>
                      <p><b>APU Visit Comments:</b>
                      {{certData['apuShowVisitCertifications'].apuVisitComments}}</p>
                  </div>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Last Visit/Inspection</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Last Visit Info</b></div>
                </mat-toolbar> -->
                <br>
                <div class="w3-row-padding fontpsaccord">
                <div class="w3-third font_class">
                  <p><b>Inspection Date:</b> {{certData['powerSupplyCertifications'].inspectionDate}}</p>
                  <p><b>Type of Visit:</b>{{certData['powerSupplyCertifications'].typeOfVisit}}</p>
                  <p><b>Visit Status:</b> {{certData['powerSupplyCertifications'].visitStatus}}</p>
                  <p><b>Followup Reason:</b> {{certData['powerSupplyCertifications'].followUpReason}}</p>
                  <p><b>XOC Verified Transponder Operational:</b> {{certData['powerSupplyCertifications'].xocVerified}}</p>
                  <p><b>Clean Dust And Dirt From Enclosure:</b> {{certData['powerSupplyCertifications'].cleanEnclosure}}</p>
                  <p><b>Tighten All Enclosure Hardware:</b> {{certData['powerSupplyCertifications'].tightenHardware}}</p>
                  <p><b>Inspect Wire Harnesses And Connectors:</b> {{certData['powerSupplyCertifications'].inspectConnectors}}</p>
                  <p><b>Inspect Battery Temperature Probes:</b> {{certData['powerSupplyCertifications'].inspectProbes}}</p>
                  <p><b>Meter Pan Condition:</b> {{certData['powerSupplyCertifications'].meterPanCondition}}</p>
                  <p><b>Power Co Riser Condition:</b> {{certData['powerSupplyCertifications'].powerCoRiserCondition}}</p>
                  <p><b>Battery Heater Mat Type:</b> {{certData['powerSupplyCertifications'].batteryHeaterMatType}}</p>
                  <p><b>Battery Heater Mat Quantity:</b> {{certData['powerSupplyCertifications'].batteryHeaterMatQuantity}}</p>
                  <p><b>Enclosure snow shield:</b> {{certData['powerSupplyCertifications'].enclosureSnowShield}}</p>
                  <p><b>Internal Breaker:</b> {{certData['powerSupplyCertifications'].internalBreaker}}</p>

                </div>
                <div class="w3-third font_class">
                  <p><b>Service Entrance:</b> {{certData['powerSupplyCertifications'].serviceEntrance}}</p>
                  <p><b>Receptacle type:</b> {{certData['powerSupplyCertifications'].receptacleType}}</p>
                  <p><b>Check Seizure screw/alt box:</b> {{certData['powerSupplyCertifications'].checkSeizureAltBox}}</p>
                  <p><b>Is Power Supply ID Legible:</b> {{certData['powerSupplyCertifications'].powerSupplyIdLegible}}</p>
                  <p><b>Check Lamps & LEDs:</b> {{certData['powerSupplyCertifications'].checkLampsLeds}}</p>
                  <p><b>Check For 20 Amp Hi-Magnetic Circuit Breaker:</b> {{certData['powerSupplyCertifications'].checkMagneticBreaker}}</p>
                  <p><b>Visual Inspection Of Cabinet:</b> {{certData['powerSupplyCertifications'].visualCabinetInspection}}</p>
                  <p><b>Cabinet Locked:</b> {{certData['powerSupplyCertifications'].cabinetLocked}}</p>
                  <p><b>Security Bar Present:</b> {{certData['powerSupplyCertifications'].securityBarPresent}}</p>
                  <p><b>Check Ground Connection At Cabinet:</b> {{certData['powerSupplyCertifications'].checkGroundCabinet}}</p>
                  <p><b>Battery String #1 - Fused:</b> {{certData['powerSupplyCertifications'].batteryString1Fused}}</p>
                  <p><b>Battery String #2 - Fused:</b> {{certData['powerSupplyCertifications'].batteryString2Fused}}</p>
                  <p><b>Battery String #3 - Fused:</b> {{certData['powerSupplyCertifications'].batteryString3Fused}}</p>
                  <p><b>Tamper Installed and functioning:</b> {{certData['powerSupplyCertifications'].tamperInstalledFunctioning}}</p>
                </div>
                <div class="w3-third font_class">
                  <p><b>Check LAPs:</b> {{certData['powerSupplyCertifications'].checkLaps}}</p>
                  <p><b>Cabinet Vendor:</b> {{certData['powerSupplyCertifications'].cabinetVendor}}</p>
                  <p><b>Cabinet Battery Capacity:</b> {{certData['powerSupplyCertifications'].cabinetBatteryCapacity}}</p>
                  <p><b>Check Operating Lights:</b> {{certData['powerSupplyCertifications'].checkOperatingLights}}</p>
                  <p><b>Stand By Operation:</b> {{certData['powerSupplyCertifications'].standByOperation}}</p>
                  <p><b>Follow Up Action Needed:</b> {{certData['powerSupplyCertifications'].followUpNeeded}}</p>
                  <p><b>Input Surge Arrestor:</b> {{certData['powerSupplyCertifications'].inputSurgeArrestor}}</p>
                  <p><b>Output Surge Arrestor:</b> {{certData['powerSupplyCertifications'].outputSurgeArrestor}}</p>
                  <p><b>COAX TVSS Present:</b> {{certData['powerSupplyCertifications'].coaxTvssPresent}}</p>
                  <p><b>AC Indicator Green light (ACI):</b> {{certData['powerSupplyCertifications'].acIndicatorGreenLight}}</p>
                  <p><b>Local and Remote Indicator (LRI):</b> {{certData['powerSupplyCertifications'].localRemoteIndicator}}</p>
                  <p><b>Tech:</b> {{certData['powerSupplyCertifications'].technicianNtUserName}}</p>
                  <p><b>Last Visit Comments:</b> {{certData['powerSupplyCertifications'].comments}}</p>
                </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header class="accord_cls">
                <mat-panel-title>
                  <h5 class="font-size-text"><b class="fontpsaccord">WorkItems Performed Onsite</b></h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="clr"></div>
              <!-- <mat-toolbar color="primary">
                <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Work Item On Site</b></div>
              </mat-toolbar> -->
               <div class="table-responsive">
              <table class="table">
                <tr style="font-weight: bold;">Billing Items</tr>
                <tr *ngFor="let item of workItems; let i = index">
                  <td><strong class="font-size">Sr No: </strong><span class="font-size">{{i+1}}</span><br></td>
                  <td><strong class="font-size">WorkItem: </strong><span class="font-size">{{item.workItemName}}</span><br></td>
                  <td><strong class="font-size">Work Description: </strong><span class="font-size">{{item.workItemDesc}}</span><br></td>
                  <td><strong class="font-size">Quantity: </strong><span class="font-size">{{item.quantity}}</span><br></td>
                  <!-- <td><strong class="font-size">Part Numbers: </strong><span class="font-size">{{item.partNumbers}}</span><br></td> -->
                  </tr>
                  <tr *ngIf="workItems.length==0">
                      <p style="color: black;">Work Item data not found</p>
                  </tr>
              </table>
              </div>

              <div class="table-responsive">
                <tr style="font-weight: bold;">Materials</tr>
                <table class="table">
                  <tr *ngFor="let item of workItemsMaterial; let i = index">
                    <td><strong class="font-size">Sr No: </strong><span class="font-size">{{i+1}}</span><br></td>
                    <td><strong class="font-size">Material Type: </strong><span class="font-size">{{item.materialType}}</span><br></td>
                    <td><strong class="font-size">Material Model: </strong><span class="font-size">{{item.model}}</span><br></td>
                    <td><strong class="font-size">Material Description: </strong><span class="font-size">{{item.modelDescription}}</span><br></td>
                    <td><strong class="font-size">Quantity: </strong><span class="font-size">{{item.quantity}}</span><br></td>

                  </tr>
                    <tr *ngIf="workItemsMaterial.length==0">
                        <p style="color: black;">Material data not found</p>
                    </tr>
                </table>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Photos</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Photos</b></div>
                </mat-toolbar> -->
                <br>
                <div class="w3-third font_class">
                  <p><b>1. 25’ away from PS showing general surroundings of PS :</b> {{catDate1}}</p>
                  <p><b>2. Before maintenance starts, show open door view of PS and all batteries :</b> {{catDate2}}</p>
                  <p><b>3. Picture of PS display of MAC :</b> {{catDate3}}</p>
                  <p><b>4. If no display is available or it’s an External Transponder, picture of sticker :</b> {{catDate4}}</p>
                  <p><b>5. Picture of string of batteries that shows separation, wiring and Temp probe :</b> {{catDate5}}</p>
                  <p><b>6. Battery date stamp :</b> {{catDate6}}</p>
                  <p><b>7. Coaxial ground block in PS cabinet to include input RF :</b> {{catDate7}}</p>
                  <p><b>8. PS ground :</b> {{catDate8}}</p>
                  <p><b>9. Commercial power outlet showing LAP and PS connector :</b> {{catDate9}}</p>
                  <p><b>10. Repeat step 2 after work is completed :</b> {{catDate10}}</p>
                  <p><b>11. Power Company Electric Meter :</b> {{catDate11}}</p>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Alarms</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Alarms</b></div>
                </mat-toolbar> -->
                <br>
              <div class="w3-row-padding fontpsaccord">
                <div class="w3-third font_class">
                  <p><b>Alert:</b> {{alarm}}</p>
                  <p><b>Warning:</b> {{warning}}</p>
                  <p><b>Informational:</b> {{info}}</p>
                </div>
              </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Technician Info</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Technician Info</b></div>
                </mat-toolbar> -->
                <br>
              <div class="w3-row-padding fontpsaccord">
                <div class="w3-third font_class">
                  <p><b>Name:</b> {{certData['powerSupplyCertifications'].technicianName}}</p>
                  <p><b>Phone Number:</b> {{certData['apuCertifications'].technicianNumber}}</p>
                </div>
              </div>
              </mat-expansion-panel>

              <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Telemetry Config Info</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <!-- <mat-toolbar color="primary">
                  <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Technician Info</b></div>
                </mat-toolbar> -->
                <br>
              <div class="w3-row-padding fontpsaccord">
                <div class="w3-third font_class">
                  <p><b>Sys Name:</b> {{certData['certsTelemetryConfig'].sysName}}</p>
                  <p><b>Docs Server Config:</b> {{certData['certsTelemetryConfig'].configFile}}</p>
                  <p><b>Boot File:</b> {{certData['certsTelemetryConfig'].bootFile}}</p>
                  <p><b>BootR:</b> {{certData['certsTelemetryConfig'].bootR}}</p>
                  <p><b>HwRev:</b> {{certData['certsTelemetryConfig'].hwRev}}</p>
                  <p><b>SwRev:</b> {{certData['certsTelemetryConfig'].swRev}}</p>
                  <p><b>SysDesc:</b> {{certData['certsTelemetryConfig'].sysDescr}}</p>
                </div>
              </div>
              </mat-expansion-panel>
              <!-- <mat-expansion-panel>
                <mat-expansion-panel-header style="height:45px;">
                  <mat-panel-title>
                    <h5 class="font-size-text"><b class="fontpsaccord">Self test Info</b></h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="clr"></div>
                <br>
              <div class="w3-row-padding fontpsaccord">
                <div class="w3-third font_class">
                  <p *ngIf="certData['powerSupplyCertifications'].status!=null"><b>Status:</b> {{certData['powerSupplyCertifications'].status}}</p>
                  <p *ngIf="certData['powerSupplyCertifications'].status==null"><b>Status:</b> {{'NA'}}</p>
                  <p *ngIf="certData['powerSupplyCertifications'].testDuration!=null"><b>Test Duration(Mins):</b> {{certData['powerSupplyCertifications'].testDuration}}</p>
                  <p *ngIf="certData['powerSupplyCertifications'].testDuration==null"><b>Test Duration(Mins):</b> {{'NA'}}</p>
                  <p><b>Test Start Date:</b> {{test_start_date}}</p>
                  <p><b>Test End Date:</b> {{test_end_date}}</p>
                </div>
              </div>
              </mat-expansion-panel> -->
            </mat-accordion>
            </div>
          <!-- end -->
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </mat-tab>
    <!--Image Section-->
    <mat-tab *ngIf="showPhotosEnable==1?false:true" label="Edit Photo(s)">
      <button style="margin-top: 10px;margin-bottom: 10px;" type="button" [disabled]="enablephotoStatus" matTooltip="Offline Picture Upload" class="btn btn-primary"
      (click)="openAddEntryDialogPhoto('Test')">Offline Picture Upload</button>
      <form id="photoInfoForm">
        <mat-card *ngIf="xmRepBtnEnable==1?false:true">
          <mat-card-title class="titleHeader">
            <div><button mat-raised-button matTooltip="Download PDF Report" color="primary" [disabled]="showProgressPDFBar || xmRepBtnEnable==2" (click)="downloadPDF()"><i class="fa fa-download"></i> &nbsp;<b>XM360 Report</b></button></div>
          </mat-card-title>
        </mat-card>
        <mat-card *ngFor="let imagedata of detailedImage; index as i">
          <mat-card-title class="titleHeader">
            <p [ngClass]="{'required-image': vm?.mandatoryImageInHouseCertification && imagedata.isMandatory && !imagedata.url}">
              {{imagedata.id + ". " + imagedata.name}}
             <span *ngIf="vm?.mandatoryImageInHouseCertification && imagedata.isMandatory">
                *
              </span>
            </p>
            <div *ngIf="!isAnnualInspect && imagedata.url"><i class="fa fa-info-circle fa-lg yellow"></i> &nbsp; Image
              Uploaded at {{latestDateDetail[i].uploadedDate}} .</div>
            <div *ngIf="isAnnualInspect && latestDateDetail[i].latestImage === 'Old'"><i
                class="fa fa-info-circle fa-lg yellow"></i> &nbsp; <strong>Image Uploaded at
                {{latestDateDetail[i].uploadedDate}} . Please upload latest images of PowerSupply and its
                surroundings</strong></div>
            <div *ngIf="isAnnualInspect && latestDateDetail[i].latestImage === 'New'"><i
                class="fa fa-info-circle fa-lg yellow"></i> &nbsp; Image Uploaded at
              {{latestDateDetail[i].uploadedDate}} .</div>
            <div *ngIf="isAnnualInspect && !imagedata.url"><i class="fa fa-info-circle fa-lg yellow"></i> &nbsp;
              <strong>No Image uploaded. Please upload latest images of PowerSupply and its surroundings</strong>
            </div>
          </mat-card-title>
          <mat-card-content class="imagePos">
            <br>
            <img *ngIf="imagedata.url" [src]="imagedata.url" class="imageSrc"><br>
            <img *ngIf="!imagedata.url" src="./assets/noprev.jpg" class="noPrev"><br>
            <input type="file" accept="image/x-png,image/jpeg,image/jpg" id="{{imagedata.id}}" style="display:none;"
              (change)="onselectFile($event,imagedata.id,imagedata)" #file_uploadOne>
            <img *ngIf="showPhotosEnable != 2" (click)="file_uploadOne.click()" src="../../../assets/upload.png" class="uploadIcon"><br>
            <img *ngIf="showPhotosEnable == 2" src="../../../assets/upload.png" class="uploadIcon"><br>
            <mat-label *ngIf="showPhotosEnable != 2" class="imageNav" (click)="file_uploadOne.click()"><b *ngIf="imagedata.url">Replace Photo</b><b
                *ngIf="!imagedata.url">Upload Photo</b></mat-label>
            <mat-label *ngIf="showPhotosEnable == 2" class="imageNav"><b *ngIf="imagedata.url">Replace Photo</b><b
                  *ngIf="!imagedata.url">Upload Photo</b></mat-label>
          </mat-card-content>
        </mat-card>
        <hr class="bottomLine">
      </form>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-template #maintDialog>
  <h2 class="fontPS" matDialogTitle>Do you want to Reset all the Last Visit Information or keep the existing Data</h2>
  <mat-dialog-actions align="end">
    <div class="example-button-row">
      <button mat-stroked-button (click)="resetInspection()">Reset</button>
      <button mat-stroked-button matDialogClose (click)="cancelOk();">No</button>
    </div>
  </mat-dialog-actions>
</ng-template>
<ng-template #mainDialogueReturnvisit>
  <h2 class="fontPS" matDialogTitle>This powersupply Last Certification is out of date. Please create new certification.</h2>
  <mat-dialog-actions align="end">
    <div class="example-button-row">
      <!-- <button mat-stroked-button (click)="editLastCert()">Edit last Certification</button> -->
      <button mat-stroked-button matDialogClose (click)="newCert();">Proceed</button>
    </div>
  </mat-dialog-actions>
</ng-template>
